
import { Component, OnInit, AfterViewInit, Inject, ViewEncapsulation, ViewChild, Output, Renderer2, EventEmitter } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatDialog, MatSnackBar, MatTableDataSource } from "@angular/material";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { IClinicTimeZone } from 'src/app/models/IClinicTimeZone';
import { CalendarTemplate, CalendarTemplateDay } from 'src/app/models/CalendarTemplate';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { LocationsService } from 'src/app/Services/AdminConfigurations/locations.service';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { CalDatesService } from '../cal-dates.service';
import { CopyTemplateDialogModel } from '../models';
import { CopyTemplateDialogComponent } from '../copy-template-dialog/copy-template-dialog.component';
import { SaveAsDialogComponent } from '../save-as-dialog/save-as-dialog.component';
import { ConfirmationDialogComponent } from 'src/app/ChildControls/confirmation-dialog/confirmation-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { Guid } from 'guid-typescript';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatCalendar, MatCalendarCellCssClasses, MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import moment from 'moment';
import { configuration } from 'src/environments/environment';

class AssignedListInfo {
  template: CalendarTemplate;
  color: string = 'rgb(220,220,220)'; //grey
}
enum screenMode {
  addNew = 1,
  //viewOnly = 2,
  edit = 3
}


declare let $: any;
declare let FullCalendar: any;
declare let FullCalendarInteraction: any;

class VisitDetails {
  color: string = 'rgb(220,220,220)'; //grey
  visitTypeText: string = '';
  duration: string = '';
  visitTypeId: string = '';
  allowResize: boolean = false;
}

@Component({
  selector: 'app-cal-template',
  templateUrl: './cal-template.component.html',
  styleUrls: ['./cal-template.component.css', '../slotColors.css'],
  providers: [CalDatesService]
  , encapsulation: ViewEncapsulation.None
})
export class CalTemplateComponent implements OnInit, AfterViewInit {
  public eventsData: any = [];
  public recurrenceList = ['Daily', 'Custom', 'Custom-Series'];

  public headerStartDate: string = ''; //'01/01/2020';
  public headerEndDate: string = ''; //'12/31/2020';
  public currentTemplateName: string = '';
  public lastModifiedText: string = '';
  public indayview: boolean = true;
  public providersList: IUserDetails[];
  public allLocations: IClinicTimeZone[];
  public visitTypeList: VisitDetails[];
  public BlockTypeList: any = [];
  public templateList: any[] = [];
  public mode: screenMode = 0;
  public chosenProvider: IUserDetails;
  public chosenLocation: IClinicTimeZone;
  //schosenRecurrence;
  public mainForm: FormGroup;
  templateCols = ['calendarTemplateName', 'createdOn', 'Actions'];
  public txtpreviousValue: string = '';
  private edittingTemplate: CalendarTemplate;
  private calendar;
  calview: string = 'timeGridDay';
  fulLocationVal: any;
  schService: SchedularServiceService;
  constructor(private sharedService: SharedService, private locationService: LocationsService, public schedulerService: SchedularServiceService,
    public datepipe: DatePipe, private fb: FormBuilder, private dateService: CalDatesService, public dialog: MatDialog,
    public snackBar: MatSnackBar, private toastr: ToastrService, private spinner: NgxSpinnerService, private renderer: Renderer2) {
    //   this.mainForm = fb.group({
    //     providerList: [this.providersList, []],
    //     allLocations: [this.allLocations],
    //     templateName: '',
    //     calendarInactive: false,
    //     templateNotes: ''
    // });
    //  this.datepipe=new DatePipe("en-US");
    this.mainForm = this.fb.group({
      selectedMonthYear: [new Date(), ''],
      providerList: [this.providersList, []],
      allLocationss: [this.allLocations],
      templateName: [],
      calendarInactive: [],
      templateNotes: [],
      chosenId: [0, [Validators.required, Validators.min(1)]],
      startDate: ['', [Validators.required]],
      endDate: [''],
      templateColor: ['#9ed1ff'],
      // chosenRecurrence: [ '', [ Validators.required ] ],
      recurrenceList: [this.recurrenceList],
      chosenRecurrence: ['', [Validators.required]],
      selectedRecurrence: [],
      dayMon: false,
      dayTue: false,
      dayWed: false,
      dayThu: false,
      dayFri: false,
      daySat: false,
      daySun: false,
      dayList: [],
      daysSelected: [],
      calendarc: []
    });
    this.getAllProviders();
    this.getLocations();
    this.getVisitTypes();
  }
  get chosenId() { return this.mainForm.get('chosenId'); }

  get chosenRecurrence() { return this.mainForm.get('chosenRecurrence'); }

  get invalidEndDate() {
    if (this.mainForm.errors && this.mainForm.errors.invalidEndDate)
      return true;
    return false;
  }

  get invalidNoDayChosen() {
    if (this.mainForm.errors && this.mainForm.errors.invalidNoDayChosen)
      return true;
    return false;
  }
  startDatess = new Date(1990, 0, 1);
  selectMonthDp: boolean = false;
  ngOnInit() {

    this.schService;
    this.spinner.hide();
    // this.mainForm = this.fb.group({
    //   providerList:[],
    //   allLocations:[],
    //   templateName:[],
    //   calendarInactive:[],
    //   templateNotes:[],
    //   chosenId: [ 0, [ Validators.required, Validators.min(1) ] ],
    //   startDate: [ '' ],
    //   endDate: [ '' ],
    //   chosenRecurrence: [ '', [ Validators.required ] ],
    //  // recurrenceList: [ this.recurrenceList ],
    //  // chosenRecurrence: [ '', [ Validators.required ] ],
    //   dayMon: false,
    //   dayTue: false,
    //   dayWed: false,
    //   dayThu: false,
    //   dayFri: false,
    //   daySat: false,
    //   daySun: false,
    //   dayList: []
    // });

    this.BlockTypeList.push({
      VisitId: 0,
      VisitName: "Block",
      // CssClass: "external-event bg-visittype-block",
      CssClass: "external-event bg-visittype-block",
      duration: configuration.Blockduration
    });
  }

  // chosenYearHandler(normalizedYear) {

  // }

  // chosenMonthHandler(normalizedMonth, datepicker) {
  //   
  //   this.mainForm.patchValue({
  //       selectedMonthYear:  normalizedMonth,
  //   });
  //   datepicker.close();
  //   this.getCalenderTemplatesByMonth();
  // }

  fulLocation(event) {

    this.fulLocationVal = event.target.innerText;
  }
  ondateselectionchange() {
    ;
    this.getCalenderTemplatesByMonth();
  }

  @Output()
  monthSelected: EventEmitter<moment.Moment> = new EventEmitter();
  ngAfterViewInit() {
    let buttons = document.querySelectorAll('mat-calendar .mat-calendar-previous-button,' +
      'mat-calendar .mat-calendar-next-button');
    if (buttons) {
      Array.from(buttons).forEach(button => {
        alert("hi")
        this.renderer.listen(button, "click", () => {
          alert("hi")
          this.monthSelected.emit(this.calendar.activeDate);

        });
      })
    }

    // this.ini_events($('#external-events div.external-event'));
    this.ini_events($('.external-event'));

    var Draggable = FullCalendarInteraction.Draggable;
    var containerEl = document.getElementById('external-events');

    new Draggable(containerEl, {
      itemSelector: '.external-event',
      eventData: function (eventEl) {
        let data = eventEl.dataset;

        let allowResize = (data.allowresize == (null || undefined)) ? 'true' : (data.allowresize.toLowerCase() == 'true');
        let now = new Date();
        return {
          id: Guid.create(),// 'N'.concat(now.getTime().toString()),
          title: eventEl.innerText,
          backgroundColor: window.getComputedStyle(eventEl, null).getPropertyValue('background-color'),
          borderColor: window.getComputedStyle(eventEl, null).getPropertyValue('background-color'),
          textColor: window.getComputedStyle(eventEl, null).getPropertyValue('color').concat(' !important'),
          duration: data.duration,
          durationEditable: allowResize,
          visitText: '',
          extendedProps: {
            visitTypeId: data.visittypeid, // data.visitTypeId attribute gets converted to all lowercase
            allowResize: allowResize,
            visitText: data.visitText
          }
        };
      }
    });
    this.renderCalendar();
  }
  locationChangeDD: boolean = false;
  async changeview(vw) {
    ;
    if (vw == 'Day') {
      this.selectMonthDp = false;
      this.calview = 'timeGridDay';
      this.indayview = true;
      //if(this.locationChangeDD == false){
      await this.editTemplate(this.selectedTemplate);
      // }else{
      //   this.selectedTemplate = null;
      //   await this.editTemplate(this.selectedTemplate);
      // }      
    }
    if (vw == 'Week') {
      this.selectMonthDp = false;
      this.calview = 'timeGridWeek';
      this.indayview = false;
      this.getCalenderTemplatesByWeek();
    }
    if (vw == 'Month') {
      ;
      this.selectMonthDp = true;
      this.indayview = false;
      this.cancelTemplate('Month');
      this.calview = 'dayGridMonth';
      this.mainForm.patchValue(
        {
          selectedMonthYear: new Date(this.selectedTemplate.calendarTemplatesDays[0].cDate)
        }
      );
      await this.getCalenderTemplatesByMonth();
    }
    // this.renderCalendar();
  }
  calevents: any[];
  renderCalendar(initialDate: string = '') {
    // alert("Start "+this.chosenLocation.start+"  End: "+this.chosenLocation.end)
    var Calendar = FullCalendar.Calendar;
    var self = this;
    this.calevents = this.eventsData;
    const calendarEl = document.getElementById('calendar');
    $(calendarEl).html('');
    let defaultDate = moment(new Date()).toDate();
    if (initialDate) {
      defaultDate = moment(initialDate).toDate();
    }
    this.calendar = new Calendar(calendarEl, {
      plugins: ['bootstrap', 'interaction', 'dayGrid', 'timeGrid'],
      header: false,
      'themeSystem': 'bootstrap',
      events: this.eventsData,
      slotEventOverlap: false,
      allDay: false,
      allDaySlot: false,
      editable: true,
      droppable: true, // this allows things to be dropped onto the calendar !!!
      defaultDate: defaultDate,
      slotDuration: (this.chosenLocation != null ? ("00:" + (this.chosenLocation.slotTimeDuration < 10 ? ("0" + this.chosenLocation.slotTimeDuration) : this.chosenLocation.slotTimeDuration) + ":00") : "00:15:00"),// "00:15:00",
      slotLabelInterval: (this.chosenLocation != null ? this.chosenLocation.slotTimeDuration : 15),//15,
      defaultView: this.calview,
      minTime: (this.chosenLocation != null ? this.chosenLocation.start : "08:00:00"),
      maxTime: (this.chosenLocation != null ? this.chosenLocation.end : "23:00:00"),
      displayEventTime: false,
      eventTextColor: 'rgba(0, 0, 0, 0.87) !important',
      eventRender: function (event) {
        ;
        this.calevents = this.newEventsData;
        let e = $(event.el);
        // ;
        e.append("<div id='" + event.event.extendedProps.visitTypeId + "'></div>");
        let text = e.find('.fc-title').text()
        if (event.event.extendedProps.visitTypeId == '0' || event.event.extendedProps.visitTypeId == undefined) {
          if (event.event.extendedProps.visitText != undefined)
            text = event.event.extendedProps.visitText;
          // if (e.find('.fc-title').extendedProps.visitTypeId == 'Block') {
          // let text = e.find('.fc-title').text()
          e.find('.fc-title').text('');
          // e.find('.fc-title').append("<span id='blocktext' contenteditable='true' onfocusout='blockdbclick()'>" + text + "</span>")
          e.find('.fc-title').append("<span id='blocktext' contenteditable='true' onkeyup='blockeventKeyUp(this)'>" + text + "</span>")
            .focusout(function (blocktext) {

              //   let a = event.event._calendar.getElementById(blocktext.target.id);
              //   alert('Visit' + blocktext.target._def.extendedProps.visitTypeId);
              let btxt = blocktext;// event.event._calendar.getElementById('blocktext');           
              //  text=btxt.target.innerText;
              event.event.setExtendedProp('visitText', btxt.target.innerText);
              event.event.setProp('title', btxt.target.innerText);
              event.el.text = btxt.target.innerText;
              if (event.el.text == '' || event.el.text == undefined) {

                //  alert(event.el.text+'empty')
                event.event.setExtendedProp('visitText', btxt.target.innerText);

                event.event.setProp('title', 'Block');
                //  text=btxt.target.innerText;
                //this.blockeventKeyUp(obj)
                var diva = document.getElementById('blocktext');
                setTimeout(function () {
                  diva.focus();
                }, 0);
              }
              //    a.title = event.event._calendar.getElementById('blocktext').value==''?'Block':event.event._calendar.getElementById('blocktext').value;
            });
        }
        e.attr("data-toggle", "tooltip")
        e.attr("title", text)

        if (this.state.viewType == 'timeGridDay') {
          e.find('.fc-content').append("<span style='position:absolute;bottom:0px;right:0px' class='closeon pull-right text-danger'>&#10005;</span>");
        }
        e.find('.closeon')
          .click(function () {
            ;
            let a = event.event._calendar.getEventById(event.event.id);
            a.remove();
          });
      },
      drop: function (info) {
        ;
        var tt = this;
        var lst = tt.eventData;
        self.handleEventDrop(info);
        //  alert("drop called");
        //let lt=this.eventsData.filter(c=>c.startTime==info.event.startTime && c.visitTypeId==info.event.visitTypeId);
        // if(lt!=null || lt.lenth==0)
        // info.revert();
      }
      , eventDrop: function (event) {
        // alert("event drop called");
        if (event.event.extendedProps.visitTypeId == '0' || event.event.extendedProps.visitTypeId == undefined) {
          event.event.setExtendedProp('visitText', self.txtpreviousValue);
          event.event.setProp('title', self.txtpreviousValue);
          event.el.text = self.txtpreviousValue;
        }
        // ;
        // var tt = this;
        // let lt=this.eventsData.filter(c=>c.startTime==info.event.startTime && c.visitTypeId==info.event.visitTypeId);
        // if(lt!=null || lt.lenth==0)
        // info.revert()
      },
      eventDragStart: function eventDragStart(info) {
        if (info.event.extendedProps.visitTypeId == '0' || info.event.extendedProps.visitTypeId == undefined) {
          let e = $(info.el);
          e.append("<div id='" + info.event.extendedProps.visitTypeId + "'></div>");
          let text = e.find('.fc-title').text();
          //  alert("drag start"+ text);
          self.txtpreviousValue = text;
        }
      },
      eventDragStop: function eventDragStop(event) {
        //  alert("drag end"+ self.txtpreviousValue);
        if (event.event.extendedProps.visitTypeId == '0' || event.event.extendedProps.visitTypeId == undefined) {
          event.event.setExtendedProp('visitText', self.txtpreviousValue);
          event.event.setProp('title', self.txtpreviousValue);
          event.el.text = self.txtpreviousValue;
        }
      },
      eventResize: function eventResize(event, delta, revertFunc) {
        if (event.event.extendedProps.visitTypeId == '0' || event.event.extendedProps.visitTypeId == undefined) {
          ;
          let e = $(event.el);
          let text = e.find('.fc-title').text();
          event.event.setExtendedProp('visitText', self.txtpreviousValue);
          event.event.setProp('title', self.txtpreviousValue);
          event.el.text = self.txtpreviousValue;
        }
      },
      eventResizeStart: function (info) {
        if (info.event.extendedProps.visitTypeId == '0' || info.event.extendedProps.visitTypeId == undefined) {
          let e = $(info.el);
          e.append("<div id='" + info.event.extendedProps.visitTypeId + "'></div>");
          let text = e.find('.fc-title').text();
          self.txtpreviousValue = text;
        }

      }
    });
    this.calendar.render();
    setTimeout(() => {
      $(".fc-scroller").scrollTop('px');
    }, 0);


    if (this.calview != 'timeGridDay') {
      this.calendar.gotoDate(this.datepipe.transform(this.currentdate, "yyyy-MM-dd"));
    }
  }

  ini_events(ele) {
    ele.toArray().forEach(function (_e, i) {
      // create an Event Object (http://arshaw.com/fullcalendar/docs/event_data/Event_Object/)
      // it doesn't need to have a start or end
      var eventObject = {
        title: $.trim($(_e).text()) // use the element's text as the event title
      }

      // store the Event Object in the DOM element so we can get to it later
      $(_e).data('eventObject', eventObject)

      // make the event draggable using jQuery UI
      $(_e).draggable({
        zIndex: 1070,
        revert: true, // will cause the event to go back to its
        revertDuration: 0  //  original position after the drag
      });
    });
  }

  getAllProviders() {
    // this.sharedService.getAllUsersByRole("Doctor").subscribe(data => {
    //   this.providersList = data;
    // });
    this.sharedService.getAllUsersByRoleWithOutLocId("Doctor").subscribe(data => {
      this.providersList = data;
    });
  }
  handleEventDrop(info) {
    ;

    let lt = this.calevents.filter((f) => moment(f.start).toDate().getDate() == moment(info.date).toDate().getDate() &&
      moment(f.start).toDate().getMonth() == moment(info.date).toDate().getMonth() &&
      moment(f.start).toDate().getFullYear() == moment(info.date).toDate().getFullYear() &&
      moment(f.start).toDate().getTime() == moment(info.date).toDate().getTime());
    if (lt != null && lt.length > 0) {
      if (lt[0].visitTypeId != $(info.draggedEl).attr("data-visittypeid")) {
        return;
      }
    }

  }
  getLocations() {
    ;
    this.locationService.getLocations().subscribe(data => {
      this.allLocations = data;
    })
  }

  getVisitTypes() {
    this.visitTypeList = [];

    this.schedulerService.getVisitTypes().subscribe(data => {
      if (data) {
        for (let i = 0; i < data.length; i++) {
          let v = new VisitDetails;
          v.visitTypeId = data[i].visitId;
          if (data[i].visitColor && data[i].visitColor != "")
            v.color = data[i].visitColor;
          if (data[i].visitDuration && Number(data[i].visitDuration) > 0) {
            let hours = 0;
            let mins = Number(data[i].visitDuration);
            if (mins >= 60) {
              hours = Math.floor(mins / 60);
              mins = mins - (hours * 60);
            }
            v.duration = hours.toString().padStart(2, '0').concat(':').concat(mins.toString().padStart(2, '0'));
            if (data[i].visitType && data[i].visitType != "")
              v.visitTypeText = data[i].visitType.concat(' ').concat(data[i].visitDuration).concat(' minutes');
            v.allowResize = false;
          }
          else {
            v.duration = '00:15';
            if (data[i].visitType && data[i].visitType != "")
              v.visitTypeText = data[i].visitType;
            v.allowResize = true;
          }
          ;
          this.visitTypeList.push(v);
        }
      }
    },
      error => {
      });
  }

  providerSelectionChanged(event) {

    this.daysSelected = [];
    this.editdays = [];
    this.calTemplateDays = [];
    this.selectMonthDp = false;
    if (event.target.value != '') {
      this.chosenProvider = this.providersList.find(provider => provider.providerId = event.target.value);
      if (this.chosenProvider && this.chosenLocation) {
        this.locationChangeDD = false;
        this.refreshTemplates(this.chosenProvider.providerId, this.chosenLocation.locationId);
        this.getTemplateDays(new Date());
      }
      else {
        this.mode = 0;
      }
    }
  }

  locationSelectionChanged(event) {
    this.selectMonthDp = false;
    this.daysSelected = [];
    this.editdays = [];
    this.calTemplateDays = [];
    if (event.target.value != '') {
      this.chosenLocation = this.allLocations.find(loc => loc.locationId == event.target.value);
      if (this.chosenProvider && this.chosenLocation) {
        this.locationChangeDD = true;
        this.eventsData = [];
        this.initialiseNewTemplate();
        this.clear();
        //this.refreshTemplates(this.chosenProvider.providerId, this.chosenLocation.locationId);
        //this.getCalenderTemplatesByMonth();
      }
      else {
        this.mode = 0;
      }
      this.getlocationbasedproviders(event.target.value);

      $('#provider_select_id').removeAttr('disabled');

    }
  }


  getlocationbasedproviders(locid) {

    this.mainForm.controls['providerList'].setValue('');
    this.mode = 0;
    this.templateList = [];
    this.templateListDataSource = new MatTableDataSource();
    this.sharedService.getselectedlocidByrole("Doctor", Number(locid)).subscribe(data => {
      this.providersList = [];
      this.providersList = data;
    });
  }
  templateListDataSource = new MatTableDataSource(this.templateList);

  refreshTemplates(provId, locId, showId = 0) {
    this.selectMonthDp = false;
    this.daymonthBtnView = false;
    this.mainForm.patchValue({
      selectedMonthYear: new Date(),
      dayMon: false,
      dayTue: false,
      dayWed: false,
      dayThu: false,
      dayFri: false,
      daySat: false,
      daySun: false
    });
    this.mainForm.controls.dayMon.patchValue(false);
    this.mainForm.controls.dayTue.patchValue(false);
    this.mainForm.controls.dayWed.patchValue(false);
    this.mainForm.controls.dayThu.patchValue(false);
    this.mainForm.controls.dayFri.patchValue(false);
    this.mainForm.controls.daySat.patchValue(false);
    this.mainForm.controls.daySun.patchValue(false);
    // this.currentTemplateName = 'New Template';
    // this.headerStartDate = '';
    // this.headerEndDate = '';
    this.initBlankSlots();
    this.mode = 0;
    this.schedulerService.getCalendarTemplates(provId, locId).subscribe(data1 => {
      this.templateList = data1;
      this.templateListDataSource.data = this.templateList;
      this.templateListDataSource.filterPredicate =
        (data: CalendarTemplate, filter: string) => data.calendarTemplateName.indexOf(filter) != -1;

      if ((!this.templateList || this.templateList.length == 0) && this.cancelbtn == false) {
        this.initialiseNewTemplate();
        //this.initBlankSlots();
        //this.mode = screenMode.addNew;  
      }
      else {
        //this.renderCalendar();
        if (showId > 0) {
          let viewTemp = this.templateList.find(t => t.calendarTemplateId == showId);
          if (viewTemp) {
            this.displayTemplate(viewTemp);
          }
          this.edittingTemplate = null;
        }
        this.mode = 0;
        this.cancelbtn = false;
      }
      if (this.locationChangeDD == true) {
        this.templateList = [];
        this.templateListDataSource = new MatTableDataSource();
      }

      this.isSaved = false;
      this.spinner.hide();
    },
      error => {
        this.isSaved = false;
        this.spinner.hide();
        //this.alertService.error("There was a problem loading availabilities: "+error);
      });
  }
  // On input focus: setup filterPredicate to only filter by input column
  setupFilter(column: string) {
    this.templateListDataSource.filterPredicate = (d: CalendarTemplate, filter: string) => {
      const textToSearch = d[column] && d[column].toLowerCase() || '';
      this.templateList = this.templateListDataSource.data;
      return textToSearch.indexOf(filter) !== -1;
    };

  }

  applyFilter(filterValue: string) {
    this.templateListDataSource.filter = filterValue.trim().toLowerCase();
  }
  initialiseNewTemplate() {

    this.clear();
    const provider_select_id = $('#provider_select_id').val();
    if (provider_select_id == null) {
      this.toastr.warning('Please Select Provider and Location');
    } else {
      this.selectMonthDp = false;
      this.daymonthBtnView = false;
      if (this.chosenProvider && this.chosenLocation) {
        if (this.calview != 'timeGridDay') {
          this.calview = 'timeGridDay'
        }
        this.initBlankSlots();
        this.daysSelected = [];
        this.editdays = [];
        this.calTemplateDays = [];
        this.mainForm.controls.templateName.patchValue('');
        this.mainForm.controls.calendarInactive.patchValue(false);
        this.mainForm.controls.templateNotes.patchValue('');
        this.headerStartDate = '';
        this.headerEndDate = '';
        this.currentTemplateName = 'New Template';
        this.lastModifiedText = '';
        this.mainForm.controls.startDate.patchValue('');
        this.mainForm.controls.endDate.patchValue('');
        this.mainForm.controls.templateColor.patchValue('#9ed1ff ');
        this.mainForm.controls.chosenRecurrence.patchValue('');
        this.mainForm.controls.dayMon.patchValue(false);
        this.mainForm.controls.dayTue.patchValue(false);
        this.mainForm.controls.dayWed.patchValue(false);
        this.mainForm.controls.dayThu.patchValue(false);
        this.mainForm.controls.dayFri.patchValue(false);
        this.mainForm.controls.daySat.patchValue(false);
        this.mainForm.controls.daySun.patchValue(false);
        this.mainForm.patchValue({
          selectedMonthYear: moment(new Date()).toDate(),
        });
        this.mode = screenMode.addNew;
        let d = this.dateService.todayDateOnly();
        this.getTemplateDays(moment(d).toDate());

      } else {
        this.toastr.warning('Please Select Provider and Location');
      }
    }
  }

  deleteTemplate(element) {
    alert("Deletion of templates is not yet available.");
  }

  saveAsTemplate(element) {
    this.openSaveAsDialog(element);
  }

  copyTemplate(element) {
    this.openCopyTemplateDialog(element);
  }
  currentdate: any = new Date();
  selectedTemplate: any;
  daymonthBtnView: boolean = false;
  editTemplate(element) {
    ;
    // this.mainForm.value.chosenRecurrence=null;
    var recurr = '';
    this.mainForm.controls.chosenRecurrence.patchValue('');
    //this.cancelTemplate(null);
    this.daysSelected = [];
    this.editdays = [];
    this.selectedTemplate = element;
    this.calview = "timeGridDay";
    if (this.indayview === false) {
      this.indayview = true;
    }
    if (this.selectMonthDp === true) {
      this.selectMonthDp = false;
    }
    //selectMonthDp
    this.mainForm.patchValue({
      dayMon: false,
      dayTue: false,
      dayWed: false,
      dayThu: false,
      dayFri: false,
      daySat: false,
      daySun: false
    });
    if (element !== undefined) {
      this.daymonthBtnView = true;

      this.schedulerService.getCalendarTemplate(element.calendarTemplateId).subscribe(data => {
        this.displayTemplate(data[0]);
        ;
        //if (data[0].recurrence == 'Custom') {
        this.daysSelected = data[0].calendarTemplatesDays[0].daysselected;
        // this.editdays=[];
        if (data[0].isActive)
          data[0].calendarTemplatesDays[0].daysselected.forEach(c => {
            this.editdays.push(c);
          });
        //this._calendar.updateTodaysDate();
        // }
        // else {
        //   this.daysSelected = [];
        //   this.editdays = [];
        // }
        this.mainForm.controls.templateName.patchValue(data[0].calendarTemplateName);
        if (data[0].calendarTemplatesDays != null) {
          if (data[0].calendarTemplatesDays[0] != null || data[0].calendarTemplatesDays[0] != undefined) {
            this.mainForm.patchValue(
              {
                startDate: moment(data[0].calendarTemplatesDays[0].cDate).toDate(),
                endDate: moment(data[0].calendarTemplatesDays[0].cDateTo).toDate(),
                templateColor: data[0].templateColor,
                chosenRecurrence: data[0].recurrence,
                selectedRecurrence: data[0].recurrence,
                selectedMonthYear: moment(data[0].calendarTemplatesDays[0].cDate).toDate()
              }
            );
            recurr = data[0].recurrence;
            this.currentdate = data[0].calendarTemplatesDays[0].cDate;
            this.headerStartDate = data[0].calendarTemplatesDays[0].cDate.toString().split('T')[0];
            if (data[0].calendarTemplatesDays[0].cDateTo.toString().split('T')[0] == '2050-01-01') {
              this.headerEndDate = '';
              this.mainForm.patchValue({
                endDate: ''
              });
            }
            else {
              this.headerEndDate = data[0].calendarTemplatesDays[0].cDateTo.toString().split('T')[0];
            }
          }
          if (data[0].calendarTemplatesDays[0].dayofweek != null) {
            ;
            var daylist = data[0].calendarTemplatesDays[0].dayofweek.split(', ');
            // if (daylist.length >= 7)
            //   this.mainForm.controls.chosenRecurrence.patchValue('Daily');
            // else
            //   this.mainForm.controls.chosenRecurrence.patchValue('Custom');
            if (daylist.length > 0) {
              if (daylist.includes('Monday'))
                this.mainForm.controls.dayMon.patchValue(true);
              if (daylist.includes('Tuesday'))
                this.mainForm.controls.dayTue.patchValue(true);
              if (daylist.includes('Wednesday'))
                this.mainForm.controls.dayWed.patchValue(true);
              if (daylist.includes('Thursday'))
                this.mainForm.controls.dayThu.patchValue(true);
              if (daylist.includes('Friday'))
                this.mainForm.controls.dayFri.patchValue(true);
              if (daylist.includes('Saturday'))
                this.mainForm.controls.daySat.patchValue(true);
              if (daylist.includes('Sunday'))
                this.mainForm.controls.daySun.patchValue(true);
            }
          }
        }
        this.edittingTemplate = data[0];
        this.mode = screenMode.edit;
        var d = moment(this.currentdate).toDate();
        d.setMonth(d.getMonth() - 1);
        var nextdt = this.datepipe.transform(d, "yyyy-MM-dd")
        this.mainForm.controls.calendarc.setValue(nextdt);
        this.getTemplateDays(this.currentdate);
      },
        error => {
          //this.alertService.error("There was a problem loading availabilities: "+error);
        });
      this.mainForm.controls.chosenRecurrence.disable();
      this.schedulerService.getAppCountbyTemplateId(element.calendarTemplateId, sessionStorage.getItem("userId").toString()).subscribe(cnt => {
        if (cnt > 0) {
          this.mainForm.controls.templateName.disable();
          //this.mainForm.controls.startDate.disable();
          //this.mainForm.controls.endDate.disable();
          this.mainForm.controls.templateColor.disable();
          this.mainForm.controls.chosenRecurrence.disable();
        }
      });
      this.mainForm.patchValue(
        {
          chosenRecurrence: recurr
        }
      );

    } else {
      this.daymonthBtnView = false;
      this.toastr.warning('Select the Template')
    }
  }

  deactivatetemplateid: number = 0;
  inactiveCheckBox = false;
  displayTemplate(template: CalendarTemplate) {
    ;

    this.deactivatetemplateid = template.calendarTemplateId;
    this.initBlankSlots();
    const ct = template;
    this.mainForm.controls.calendarInactive.patchValue(!ct.isActive);
    this.mainForm.controls.templateNotes.patchValue(ct.calendarTemplateDescription);
    let s = 'Last modified by ';
    if (ct.modifiedBy)
      s = s + ct.modifiedBy;
    else
      s = s + 'unknown';
    s = s + ' on ';
    if (ct.modifiedOn) {
      let datePipe = new DatePipe("en-US");
      s = s + datePipe.transform(ct.modifiedOn, 'MM/dd/yyyy');
    }
    else
      s = s + 'unknown';
    this.lastModifiedText = s;

    this.currentTemplateName = ct.calendarTemplateName;
    if (ct.calendarTemplatesDays && ct.calendarTemplatesDays.length) {
      let newEventsData = [];
      if (ct.recurrence == 'Custom') {
        this.daysSelected = ct.calendarTemplatesDays[0].daysselected;
        this.editdays = [];
        ct.calendarTemplatesDays[0].daysselected.forEach(c => {
          this.editdays.push(c);
        });

      }
      else {
        this.daysSelected = [];
        this.editdays = [];
      }
      if (this.daysSelected.length > 0) {
        this.isload = true;
      }
      else
        this.isload = false;

      for (let i = 0; i < ct.calendarTemplatesDays.length; i++) {
        let dtStartDateTime = moment(ct.calendarTemplatesDays[i].startTime).toDate();
        let dtEndDateTime = moment(ct.calendarTemplatesDays[i].endTime).toDate();
        let today = moment(ct.calendarTemplatesDays[i].cDate).toDate();//this.dateService.todayDateOnly();
        let dtEventStartDateTime = this.dateService.setTimeValue(today, dtStartDateTime);
        let dtEventEndDateTime = this.dateService.setTimeValue(today, dtEndDateTime);

        let color: string = 'rgb(220,220,220)'; //grey
        let visitTypeText: string = '';
        let allowResize: boolean = true;
        if (this.visitTypeList) {
          const visitEntry = this.visitTypeList.find(entry => entry.visitTypeId == ct.calendarTemplatesDays[i].visitTypeId.toString());
          if (visitEntry) {
            color = visitEntry.color;
            visitTypeText = visitEntry.visitTypeText;
            allowResize = visitEntry.allowResize;
          }
          else {
            color = '#bebebe';// '#D6B484';
            visitTypeText = (ct.calendarTemplatesDays[i].visitText == null || ct.calendarTemplatesDays[i].visitText == '') ? 'Block' : ct.calendarTemplatesDays[i].visitText;
            allowResize = false;
          }
        }

        for (let m = 0; m < ct.calendarTemplatesDays[i].bookinglimit; m++) {
          newEventsData.push({
            id: Guid.create(),// ct.calendarTemplatesDays[i].calendarTemplateId.toString().concat(m.toString()),
            start: dtEventStartDateTime,
            end: dtEventEndDateTime,
            title: visitTypeText,
            color: color,
            durationEditable: allowResize,
            extendedProps: {
              visitTypeId: ct.calendarTemplatesDays[i].visitTypeId.toString(),
              allowResize: allowResize,
              visitText: ct.calendarTemplatesDays[i].visitText
            }
          });
        }
      }
      ;
      this.eventsData = newEventsData;
      //  alert(ct.calendarTemplatesDays[0].cDate.toString());
      this.renderCalendar(ct.calendarTemplatesDays[0].cDate.toString());
    }

    if (template.isActive) {
      this.inactiveCheckBox = false;
    } else {
      this.inactiveCheckBox = true;
    }
  }
  isSaved: boolean = false;
  saveTemplate() {
    ;
    if (this.isSaved == false) {
      this.isSaved = true;
      if (this.mode == screenMode.addNew) {
        this.spinner.show();
        this.addTemplate();

      }
      else if (this.mode == screenMode.edit) {
        this.spinner.show();
        this.updateTemplate();
      }
    }
  }
  dateValueChanged(eve) {
    //alert(eve)
  }
  compareTwoDates() {
    ;
    if (this.mainForm.controls['endDate'].value !== '' && this.mainForm.controls['endDate'].value !== undefined && this.mainForm.controls['endDate'].value !== null) {
      if (new Date(this.mainForm.controls['endDate'].value) < new Date(this.mainForm.controls['startDate'].value)) {
        if (this.mainForm.controls['chosenRecurrence'].value == 'Daily') {
          this.mainForm.patchValue({
            endDate: this.mainForm.controls.startDate.value
          });
        }
        else {
          this.mainForm.patchValue({
            endDate: '',
          });
          this.toastr.error('End date can\'t before start date');
        }
      }
    }
    if (this.mainForm.controls['chosenRecurrence'].value != null) {
      if (this.mainForm.controls['chosenRecurrence'].value == 'Daily') {
        this.mainForm.patchValue({
          endDate: this.mainForm.controls.startDate.value
        });
      }
    }
  }
  public cancelbtn: boolean = false;
  public cancelTemplate(value) {
    ;
    if (value == '') {
      this.calview = 'timeGridDay';
      if (this.mode == screenMode.addNew) {
        this.initBlankSlots();
        this.mode = 0;
      }
      else if (this.mode == screenMode.edit) {
        if (this.templateList && this.templateList.length > 0 && this.edittingTemplate) {
          let viewTemp = this.templateList.find(t => t.calendarTemplateId == this.edittingTemplate.calendarTemplateId);
          if (viewTemp) {
            this.displayTemplate(viewTemp);
            this.edittingTemplate = null;
            this.mode = 0;
          }
        }
      }
    } else {
      //this.calview='dayGridMonth';
      this.calview = 'timeGridDay';
      if (this.mode == screenMode.addNew) {
        this.initBlankSlots();
        this.mode = 0;
      }
      else if (this.mode == screenMode.edit) {
        if (this.templateList && this.templateList.length > 0 && this.edittingTemplate) {
          let viewTemp = this.templateList.find(t => t.calendarTemplateId == this.edittingTemplate.calendarTemplateId);
          if (viewTemp) {
            this.displayTemplate(viewTemp);
            this.edittingTemplate = null;
            this.mode = 0;
          }
        }
      }
    }
    this.cancelbtn = true;
    this.refreshTemplates(this.chosenProvider.providerId, this.chosenLocation.locationId);
    ;
    if (value != 'Month')
      this.clear();
  }

  clear() {
    this.mainForm.controls.templateName.patchValue('');
    this.mainForm.controls.calendarInactive.patchValue(false);
    this.mainForm.controls.templateNotes.patchValue('');
    this.headerStartDate = '';
    this.headerEndDate = '';
    this.lastModifiedText = '';
    this.currentTemplateName = '';
    this.isSaved = false;
    this.mainForm.controls.templateName.enable();
    this.mainForm.controls.startDate.enable();
    this.mainForm.controls.endDate.enable();
    this.mainForm.controls.templateColor.enable();
    this.mainForm.controls.chosenRecurrence.enable();

  }
  private addTemplate() {

    // if(this.mainForm.invalid){
    //   alert("hello")
    //   return;
    // }
    if (this.mainForm.value.chosenRecurrence == 'Custom' && this.mainForm.value.startDate == '') {
      this.mainForm.patchValue(
        {
          startDate: moment(this.dateService.todayDateOnly()).toDate()
        }
      )
    }
    if (this.chosenProvider && this.chosenLocation && this.mainForm.controls.templateName.value
      && this.mainForm.value.chosenRecurrence !== '' && this.mainForm.value.startDate !== '') {
      let slotList = this.calendar.getEvents();
      if (slotList && slotList.length) {
        // alert("blocktext is"+ slotList[0]._def.extendedProps.visitText);
        let t = new CalendarTemplate;
        t.calendarTemplateId = 0;
        t.calendarTemplateName = this.mainForm.controls.templateName.value;
        t.calendarTemplateDescription = this.mainForm.controls.templateNotes.value;
        t.providerId = this.chosenProvider.providerId;
        t.locationId = this.chosenLocation.locationId;
        t.createdOn = new Date();
        //t.createdBy = provId;
        t.createdBy = sessionStorage.getItem("userId").toString();
        t.modifiedOn = new Date();
        //t.modifiedBy = provId;
        t.modifiedBy = sessionStorage.getItem("userId").toString();
        t.isActive = !this.mainForm.controls.calendarInactive.value;
        t.templateColor = this.mainForm.controls.templateColor.value;
        t.recurrence = this.mainForm.value.chosenRecurrence;
        t.calendarTemplatesDays = [];

        // link to todays day FIXME
        let d = this.dateService.todayDateOnly();
        var weekdayNum = d.getDay();
        var chosenDay: string;
        if (weekdayNum == 0)
          chosenDay = 'Sunday';
        else if (weekdayNum == 1)
          chosenDay = 'Monday';
        else if (weekdayNum == 2)
          chosenDay = 'Tuesday';
        else if (weekdayNum == 3)
          chosenDay = 'Wednesday';
        else if (weekdayNum == 4)
          chosenDay = 'Thursday';
        else if (weekdayNum == 5)
          chosenDay = 'Friday';
        else if (weekdayNum == 6)
          chosenDay = 'Saturday';
        let dayList: string[];
        switch (this.mainForm.controls.chosenRecurrence.value) {
          case 'Monday to Friday':
            dayList = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
            break;
          case 'Daily':
            const d1: Date = moment(this.mainForm.controls.startDate.value).toDate();
            const weekday = d1.getDay();
            dayList = [];
            if (weekday == 1)
              dayList.push('Monday');
            else if (weekday == 2)
              dayList.push('Tuesday');
            else if (weekday == 3)
              dayList.push('Wednesday');
            else if (weekday == 4)
              dayList.push('Thursday');
            else if (weekday == 5)
              dayList.push('Friday');
            else if (weekday == 6)
              dayList.push('Saturday');
            else
              dayList.push('Sunday');
            break;
          case 'Custom-Series':
            dayList = [];
            if (this.mainForm.controls.dayMon.value == true)
              dayList.push('Monday');
            if (this.mainForm.controls.dayTue.value == true)
              dayList.push('Tuesday');
            if (this.mainForm.controls.dayWed.value == true)
              dayList.push('Wednesday');
            if (this.mainForm.controls.dayThu.value == true)
              dayList.push('Thursday');
            if (this.mainForm.controls.dayFri.value == true)
              dayList.push('Friday');
            if (this.mainForm.controls.daySat.value == true)
              dayList.push('Saturday');
            if (this.mainForm.controls.daySun.value == true)
              dayList.push('Sunday');
            break;
          default:
            dayList = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
            break;
        }
        ;
        if (dayList.length == 0 && this.mainForm.value.chosenRecurrence === 'Custom-Series') {
          this.toastr.warning("Please select any week day for Custom");
          this.spinner.hide();
          this.isSaved = false;
          return;
        } else {
          // for Custom-Series
          if (this.mainForm.value.chosenRecurrence == 'Custom-Series' || this.mainForm.value.chosenRecurrence == 'Daily') {
            for (let d = 0; d < dayList.length; d++) {
              for (let i = 0; i < slotList.length; i++) {

                let ctd = new CalendarTemplateDay;
                ctd.dayofweek = dayList[d];;//''; // chosenDay;
                // ctd.startTime = this.dateService.dateTimeAsString(slotList[i].start);
                // ctd.endTime = this.dateService.dateTimeAsString(slotList[i].end);
                ctd.startTime = (this.mainForm.value.startDate == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(this.mainForm.value.startDate)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].start));
                if (slotList[i].end == null) {
                  let endhour = new Date(slotList[i].start).getHours() + 1;
                  var slotend = moment(moment(slotList[i].start).toDate().setHours(endhour)).toDate();
                  ctd.endTime = (this.mainForm.controls.endDate.value == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(this.mainForm.controls.endDate.value)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(moment(slotend).toDate().toDateString()));
                }
                else
                  ctd.endTime = (this.mainForm.controls.endDate.value == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(this.mainForm.controls.endDate.value)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].end));

                ctd.visitTypeId = slotList[i].extendedProps.visitTypeId;
                // alert("blocktext is"+ slotList[0]._def.extendedProps.visitText);
                ctd.visitCategoryId = 0;
                ctd.visitCategoryName = '';
                ctd.CTDayId = 0;
                ctd.calendarTemplateId = 0;
                //ctd.cDate = this.mainForm.value.startDate;
                //ctd.cDateTo = this.mainForm.value.endDate==''?'2050-01-01': this.mainForm.value.endDate;

                var tempmedexpDate = this.datepipe.transform(this.mainForm.value.startDate, 'yyyy-MM-dd');
                ctd.cDate = tempmedexpDate != null ? moment(tempmedexpDate).toDate().toDateString() : null;
                if (this.mainForm.value.endDate != null && this.mainForm.value.endDate !== undefined && this.mainForm.value.endDate != '') {
                  var lowrevDate = this.datepipe.transform(this.mainForm.value.endDate, 'yyyy-MM-dd');
                  ctd.cDateTo = lowrevDate != null ? moment(lowrevDate).toDate().toDateString() : null;
                } else {
                  var lowrevDate = this.datepipe.transform('2050-01-01', 'yyyy-MM-dd');
                  ctd.cDateTo = lowrevDate != null ? moment(lowrevDate).toDate().toDateString() : null;
                }
                //worked Code
                //  ctd.cDate = (this.mainForm.value.startDate == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(this.mainForm.value.startDate)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].start));
                // ctd.cDateTo = (this.mainForm.controls.endDate.value == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(this.mainForm.controls.endDate.value)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].end));

                // ctd.bookinglimit = slotHour.slot[j].numBookings;
                ctd.visitText = slotList[i]._def.extendedProps.visitText == null ? "" : slotList[i]._def.extendedProps.visitText;
                var numbooking = slotList.filter(c => c.calendarTemplateId == ctd.calendarTemplateId && c.start == ctd.startTime && c.end == ctd.endTime);
                ctd.bookinglimit = numbooking.length;// 1;
                t.calendarTemplatesDays.push(ctd);
              }
            }
          }
          else if (this.mainForm.value.chosenRecurrence == 'Custom') {
            if (this.daysSelected.length == 0) {
              this.toastr.error("Please select days for which template is to be applied");
              this.isSaved = false;
              this.spinner.hide();
              return;
            }
            else {
              ;
              for (let d = 0; d < this.daysSelected.length; d++) {
                for (let i = 0; i < slotList.length; i++) {
                  let ctd = new CalendarTemplateDay;
                  const d1: Date = moment(this.daysSelected[d]).toDate();
                  const weekday = d1.getDay();
                  dayList = [];
                  if (weekday == 1)
                    ctd.dayofweek = 'Monday';
                  else if (weekday == 2)
                    ctd.dayofweek = 'Tuesday';
                  else if (weekday == 3)
                    ctd.dayofweek = 'Wednesday';
                  else if (weekday == 4)
                    ctd.dayofweek = 'Thursday';
                  else if (weekday == 5)
                    ctd.dayofweek = 'Friday';
                  else if (weekday == 6)
                    ctd.dayofweek = 'Saturday';
                  else
                    ctd.dayofweek = 'Sunday';
                  // ctd.dayofweek = dayList[d];;//''; // chosenDay;
                  // ctd.startTime = this.dateService.dateTimeAsString(slotList[i].start);
                  // ctd.endTime = this.dateService.dateTimeAsString(slotList[i].end);
                  // (this.mainForm.value.startDate == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(this.mainForm.value.startDate)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].start));
                  ctd.startTime = this.daysSelected[d].concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].start));
                  if (slotList[i].end == null) {
                    let endhour = new Date(slotList[i].start).getHours() + 1;
                    var slotend = moment(moment(slotList[i].start).toDate().setHours(endhour)).toDate();
                    ctd.endTime = this.daysSelected[d].concat('T').concat(this.dateService.extractTimeFromDateTimeString(moment(slotend).toDate().toDateString()));// (this.mainForm.controls.endDate.value == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(this.mainForm.controls.endDate.value)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].end));
                  }
                  else
                    ctd.endTime = this.daysSelected[d].concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].end));// (this.mainForm.controls.endDate.value == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(this.mainForm.controls.endDate.value)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].end));

                  ctd.visitTypeId = slotList[i].extendedProps.visitTypeId;
                  // alert("blocktext is"+ slotList[0]._def.extendedProps.visitText);
                  ctd.visitCategoryId = 0;
                  ctd.visitCategoryName = '';
                  ctd.CTDayId = 0;
                  ctd.calendarTemplateId = 0;
                  //ctd.cDate = this.mainForm.value.startDate;
                  //ctd.cDateTo = this.mainForm.value.endDate==''?'2050-01-01': this.mainForm.value.endDate;
                  ctd.cDate = this.daysSelected[d];
                  ctd.cDateTo = this.daysSelected[d];
                  // var tempmedexpDate = this.datepipe.transform(this.mainForm.value.startDate, 'yyyy-MM-dd');
                  // ctd.cDate = tempmedexpDate != null ? new Date(tempmedexpDate) : null;
                  // if (this.mainForm.value.endDate != null && this.mainForm.value.endDate !== undefined && this.mainForm.value.endDate != '') {
                  //   var lowrevDate = this.datepipe.transform(this.mainForm.value.endDate, 'yyyy-MM-dd');
                  //   ctd.cDateTo = lowrevDate != null ? new Date(lowrevDate) : null;
                  // } else {
                  //   var lowrevDate = this.datepipe.transform('2050-01-01', 'yyyy-MM-dd');
                  //   ctd.cDateTo = lowrevDate != null ? new Date(lowrevDate) : null;
                  // }
                  //worked Code
                  //  ctd.cDate = (this.mainForm.value.startDate == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(this.mainForm.value.startDate)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].start));
                  // ctd.cDateTo = (this.mainForm.controls.endDate.value == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(this.mainForm.controls.endDate.value)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].end));

                  // ctd.bookinglimit = slotHour.slot[j].numBookings;
                  ctd.visitText = slotList[i]._def.extendedProps.visitText == null ? "" : slotList[i]._def.extendedProps.visitText;
                  var numbooking = slotList.filter(c => c.calendarTemplateId == ctd.calendarTemplateId && c.start == ctd.startTime && c.end == ctd.endTime);
                  ctd.bookinglimit = numbooking.length;// 1;
                  t.calendarTemplatesDays.push(ctd);
                }
              }
            }
          }
        }

        ;
        this.schedulerService.insertCalendarTemplate({ ...t }, '').subscribe(data => {
          this.templateList = null;

          this.spinner.hide();
          ;
          this.isSaved = false;
          if (data.includes('Provider')) {
            this.toastr.warning(data);
            this.isSaved = false;
          } else if (data.includes('success')) {
            this.mode = 0;
            this.toastr.success(data);
            this.daysSelected = [];
            this.editdays = [];
            this.calTemplateDays = [];
            this.refreshTemplates(this.chosenProvider.providerId, this.chosenLocation.locationId);
            this.getTemplateDays(new Date());
          }
          else {
            this.toastr.warning('Template name already exists.');
            this.spinner.hide();
          }
          // this.toastr.success("Template created successfully");

          //  this.clear();
        },
          error => {
            this.isSaved = false;
            this.spinner.hide();
            //this.alertService.error("There was a problem loading availabilities: "+error);
          });
      }
      else {
        this.isSaved = false;
        this.toastr.warning('please add slots');
        this.spinner.hide();
      }
      // else
      // this.spinner.hide();
    }
    else {
      this.toastr.warning('Enter all the mandatory fields');
      this.isSaved = false;
      this.spinner.hide();
    }
  }

  async updateTemplate() {
    ;
    // await this.changeview("Day");
    // check for appointments with templateId
    if (this.chosenProvider && this.chosenLocation && this.mainForm.controls.templateName.value && this.mainForm.value.selectedRecurrence !== '' && this.mainForm.value.startDate !== '' && this.mainForm.value.startDate !== null) {
      this.schedulerService.getAppCountbyTemplateId(this.edittingTemplate.calendarTemplateId, sessionStorage.getItem("userId").toString()).subscribe(cnt => {
        if (cnt > 0) {
          const dialogRef2 = this.dialog.open(ConfirmationDialogComponent, {
            width: '340px',
            height: '370px',
            // data: { headerText: 'Appointments are associated with this template. Editing will delete the appointments from Provider Calendar and will be moved to worklist. Do you wish to continue?' }
            data: { headerText: '<ul><li>If any Date/Day is being added to the existing template, the template shall be applied to the new Date/Day. </li> <li>If any Date(s) [Custom] or Day(s) [Custom-Series]  is being unselected or being removed from the existing template, all the appointments that are in an Unconfirmed/Confirmed state for the date(s)/day(s) shall be moved to the worklist. </li><li> It should be noted that for the days/dates prior to today, there shall be no change. <br/><br/> Do you wish to proceed? </li></ul>' }
          });
          dialogRef2.afterClosed().subscribe(dialogResult => {
            if (dialogResult) {
              //  this.schedulerService.blockAppointmentbyTemplateId(this.edittingTemplate.providerId, this.edittingTemplate.calendarTemplateId, this.edittingTemplate.locationId).subscribe(datas => {
              // alert(datas)
              // this.toastr.success('Appointments moved to worklist');
              this.spinner.show();
              this.editTemplateafterCheck();
              // });
            }
            else {
              //  this.editTemplateafterCheck();
              this.isSaved = false;
              this.spinner.hide();
            }
          });
        }
        else {
          this.spinner.show();
          this.editTemplateafterCheck();
        }
      });
    }
    else {
      this.toastr.warning("Enter all the mandatory fields");
      this.isSaved = false;
      this.spinner.hide();
    }
  }

  editTemplateafterCheck() {
    ;
    if (this.chosenProvider && this.chosenLocation && this.mainForm.controls.templateName.value && this.mainForm.value.selectedRecurrence !== '' && this.mainForm.value.startDate !== '') {
      let slotList = this.calendar.getEvents();
      if (slotList && slotList.length) {
        let t = new CalendarTemplate;
        t.calendarTemplateId = this.edittingTemplate.calendarTemplateId;
        t.calendarTemplateName = this.mainForm.controls.templateName.value;
        t.calendarTemplateDescription = this.mainForm.controls.templateNotes.value;
        t.providerId = this.edittingTemplate.providerId;
        t.locationId = this.edittingTemplate.locationId;
        t.createdOn = this.edittingTemplate.createdOn;
        t.createdBy = this.edittingTemplate.createdBy;
        t.recurrence = this.mainForm.value.selectedRecurrence;
        t.modifiedOn = new Date();
        //t.modifiedBy = provId;
        t.modifiedBy = sessionStorage.getItem("userId").toString();
        t.isActive = !this.mainForm.controls.calendarInactive.value;
        t.templateColor = this.mainForm.controls.templateColor.value;
        t.calendarTemplatesDays = [];

        // link to todays day FIXME
        let d = this.dateService.todayDateOnly();
        var weekdayNum = d.getDay();
        var chosenDay: string;
        if (weekdayNum == 0)
          chosenDay = 'Sunday';
        else if (weekdayNum == 1)
          chosenDay = 'Monday';
        else if (weekdayNum == 2)
          chosenDay = 'Tuesday';
        else if (weekdayNum == 3)
          chosenDay = 'Wednesday';
        else if (weekdayNum == 4)
          chosenDay = 'Thursday';
        else if (weekdayNum == 5)
          chosenDay = 'Friday';
        else if (weekdayNum == 6)
          chosenDay = 'Saturday';

        // for (let i = 0; i < slotList.length; i++) {
        //   let ctd = new CalendarTemplateDay;
        //   ctd.dayofweek = chosenDay;

        //   //fixme need to get date part from original template
        //   ctd.startTime = this.dateService.dateTimeAsString(slotList[i].start);
        //   ctd.endTime = this.dateService.dateTimeAsString(slotList[i].end);
        //   ctd.visitTypeId = slotList[i].extendedProps.visitTypeId;

        //   ctd.visitCategoryId = 0;
        //   ctd.visitCategoryName = '';
        //   ctd.CTDayId = 0;
        //   ctd.calendarTemplateId = this.edittingTemplate.calendarTemplateId;
        //   ctd.cDate = new Date();
        //   //ctd.bookinglimit = slotHour.slot[j].numBookings;
        //   var numbooking = slotList.filter(c => c.calendarTemplateId == ctd.calendarTemplateId && c.start == ctd.startTime && c.end == ctd.endTime);
        //   ctd.bookinglimit = numbooking.length;// 1;
        //   t.calendarTemplatesDays.push(ctd);
        // }
        let dayList: string[];
        switch (this.mainForm.value.selectedRecurrence) {
          case 'Monday to Friday':
            dayList = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
            break;
          case 'Daily':
            const d1: Date = moment(this.mainForm.controls.startDate.value).toDate();
            const weekday = d1.getDay();
            dayList = [];
            if (weekday == 1)
              dayList.push('Monday');
            else if (weekday == 2)
              dayList.push('Tuesday');
            else if (weekday == 3)
              dayList.push('Wednesday');
            else if (weekday == 4)
              dayList.push('Thursday');
            else if (weekday == 5)
              dayList.push('Friday');
            else if (weekday == 6)
              dayList.push('Saturday');
            else
              dayList.push('Sunday');
            break;
          case 'Custom-Series':
            dayList = [];
            if (this.mainForm.controls.dayMon.value == true)
              dayList.push('Monday');
            if (this.mainForm.controls.dayTue.value == true)
              dayList.push('Tuesday');
            if (this.mainForm.controls.dayWed.value == true)
              dayList.push('Wednesday');
            if (this.mainForm.controls.dayThu.value == true)
              dayList.push('Thursday');
            if (this.mainForm.controls.dayFri.value == true)
              dayList.push('Friday');
            if (this.mainForm.controls.daySat.value == true)
              dayList.push('Saturday');
            if (this.mainForm.controls.daySun.value == true)
              dayList.push('Sunday');
            break;
          default:
            dayList = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
            break;
        }
        if (dayList.length == 0 && this.mainForm.value.selectedRecurrence === 'Custom-Series') {
          this.toastr.warning("Please select any week day for Custom");
          this.isSaved = false;
          this.spinner.hide();
          return;
        } else {
          // for (let d = 0; d < dayList.length; d++) {
          //   for (let i = 0; i < slotList.length; i++) {
          //     let ctd = new CalendarTemplateDay;
          //     ctd.dayofweek = dayList[d];;//''; // chosenDay;
          //     // ctd.startTime = this.dateService.dateTimeAsString(slotList[i].start);
          //     // ctd.endTime = this.dateService.dateTimeAsString(slotList[i].end);
          //     ctd.startTime = (this.mainForm.controls.startDate.value == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(new Date(this.mainForm.controls.startDate.value))).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].start));
          //     ctd.endTime = (this.mainForm.controls.endDate.value == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(new Date(this.mainForm.controls.endDate.value))).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].end));

          //     ctd.visitTypeId = slotList[i].extendedProps.visitTypeId;

          //     ctd.visitCategoryId = slotList[i].extendedProps.visitTypeId;
          //     ctd.visitCategoryName = '';
          //     ctd.CTDayId = 0;
          //     ctd.calendarTemplateId = 0;
          //     var tempmedexpDate = this.datepipe.transform(this.mainForm.value.startDate, 'yyyy-MM-dd');
          //     ctd.cDate = tempmedexpDate != null ? new Date(tempmedexpDate) : null;
          //     // var lowrevDate = this.datepipe.transform(this.mainForm.value.endDate, 'yyyy-MM-dd');
          //     // ctd.cDateTo = lowrevDate != null ? new Date(lowrevDate) : null;
          //     if (this.mainForm.value.endDate != null && this.mainForm.value.endDate !== undefined && this.mainForm.value.endDate != '') {
          //       var lowrevDate = this.datepipe.transform(this.mainForm.value.endDate, 'yyyy-MM-dd');
          //       ctd.cDateTo = lowrevDate != null ? new Date(lowrevDate) : null;
          //     } else {
          //       var lowrevDate = this.datepipe.transform('2050-01-01', 'yyyy-MM-dd');
          //       ctd.cDateTo = lowrevDate != null ? new Date(lowrevDate) : null;
          //     }
          //     // ctd.cDate = this.mainForm.controls.startDate.value;
          //     // ctd.cDateTo = this.mainForm.controls.endDate.value == '' ? '2050-01-01' : this.mainForm.controls.endDate.value;
          //     // ctd.bookinglimit = slotHour.slot[j].numBookings;
          //     ctd.visitText = slotList[i]._def.extendedProps.visitText;
          //     var numbooking = slotList.filter(c => c.calendarTemplateId == ctd.calendarTemplateId && c.start == ctd.startTime && c.end == ctd.endTime);
          //     ctd.bookinglimit = numbooking.length;// 1;
          //     t.calendarTemplatesDays.push(ctd);
          //   }
          // }
          // for Custom-Series
          ;
          if (this.mainForm.value.selectedRecurrence == 'Custom-Series' || this.mainForm.value.selectedRecurrence == 'Daily') {
            for (let d = 0; d < dayList.length; d++) {
              for (let i = 0; i < slotList.length; i++) {
                let ctd = new CalendarTemplateDay;
                ctd.dayofweek = dayList[d];;//''; // chosenDay;
                // ctd.startTime = this.dateService.dateTimeAsString(slotList[i].start);
                // ctd.endTime = this.dateService.dateTimeAsString(slotList[i].end);
                ctd.startTime = (this.mainForm.value.startDate == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(this.mainForm.value.startDate)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].start));
                if (slotList[i].end == null) {
                  let endhour = new Date(slotList[i].start).getHours() + 1;
                  var slotend = moment(moment(slotList[i].start).toDate().setHours(endhour)).toDate();
                  ctd.endTime = (this.mainForm.controls.endDate.value == '' || !this.mainForm.controls.endDate.value ? "2050-01-01" : this.dateService.dateOnlyAsString(this.mainForm.controls.endDate.value)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(moment(slotend).toDate().toDateString()));
                }
                else
                  ctd.endTime = (this.mainForm.controls.endDate.value == '' || !this.mainForm.controls.endDate.value ? "2050-01-01" : this.dateService.dateOnlyAsString(this.mainForm.controls.endDate.value)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].end));

                ctd.visitTypeId = slotList[i].extendedProps.visitTypeId;
                // alert("blocktext is"+ slotList[0]._def.extendedProps.visitText);
                ctd.visitCategoryId = 0;
                ctd.visitCategoryName = '';
                ctd.CTDayId = 0;
                ctd.calendarTemplateId = 0;
                //ctd.cDate = this.mainForm.value.startDate;
                //ctd.cDateTo = this.mainForm.value.endDate==''?'2050-01-01': this.mainForm.value.endDate;

                var tempmedexpDate = this.datepipe.transform(moment(this.mainForm.value.startDate).toDate(), 'yyyy-MM-dd');
                ctd.cDate = tempmedexpDate != null ? moment(tempmedexpDate).toDate().toDateString() : null;
                if (this.mainForm.value.endDate != null && this.mainForm.value.endDate !== undefined && this.mainForm.value.endDate != '') {
                  var lowrevDate = this.datepipe.transform(moment(this.mainForm.value.endDate).toDate(), 'yyyy-MM-dd');
                  ctd.cDateTo = lowrevDate != null ? moment(lowrevDate).toDate().toDateString() : null;
                } else {
                  var lowrevDate = this.datepipe.transform('2050-01-01', 'yyyy-MM-dd');
                  ctd.cDateTo = lowrevDate != null ? moment(lowrevDate).toDate().toDateString() : null;
                }
                //worked Code
                //  ctd.cDate = (this.mainForm.value.startDate == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(this.mainForm.value.startDate)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].start));
                // ctd.cDateTo = (this.mainForm.controls.endDate.value == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(this.mainForm.controls.endDate.value)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].end));

                // ctd.bookinglimit = slotHour.slot[j].numBookings;
                ctd.visitText = slotList[i]._def.extendedProps.visitText == null ? "" : slotList[i]._def.extendedProps.visitText;
                var numbooking = slotList.filter(c => c.calendarTemplateId == ctd.calendarTemplateId && c.start == ctd.startTime && c.end == ctd.endTime);
                ctd.bookinglimit = numbooking.length;// 1;
                t.calendarTemplatesDays.push(ctd);
              }
            }
          }
          else if (this.mainForm.value.selectedRecurrence == 'Custom') {
            if (this.daysSelected.length == 0) {
              this.toastr.error("Please select days for which template is to be applied");
              this.isSaved = false;
              this.spinner.hide();
              return;
            }
            else {
              ;
              for (let d = 0; d < this.daysSelected.length; d++) {
                for (let i = 0; i < slotList.length; i++) {
                  let ctd = new CalendarTemplateDay;
                  const d1: Date = moment(this.daysSelected[d]).toDate();
                  const weekday = d1.getDay();
                  dayList = [];
                  if (weekday == 1)
                    ctd.dayofweek = 'Monday';
                  else if (weekday == 2)
                    ctd.dayofweek = 'Tuesday';
                  else if (weekday == 3)
                    ctd.dayofweek = 'Wednesday';
                  else if (weekday == 4)
                    ctd.dayofweek = 'Thursday';
                  else if (weekday == 5)
                    ctd.dayofweek = 'Friday';
                  else if (weekday == 6)
                    ctd.dayofweek = 'Saturday';
                  else
                    ctd.dayofweek = 'Sunday';
                  // ctd.dayofweek = dayList[d];;//''; // chosenDay;
                  // ctd.startTime = this.dateService.dateTimeAsString(slotList[i].start);
                  // ctd.endTime = this.dateService.dateTimeAsString(slotList[i].end);
                  // (this.mainForm.value.startDate == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(this.mainForm.value.startDate)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].start));
                  ctd.startTime = this.daysSelected[d].concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].start));
                  if (slotList[i].end == null) {
                    let endhour = new Date(slotList[i].start).getHours() + 1;
                    var slotend = moment(moment(slotList[i].start).toDate().setHours(endhour)).toDate();
                    ctd.endTime = this.daysSelected[d].concat('T').concat(this.dateService.extractTimeFromDateTimeString(moment(slotend).toDate().toDateString()));// (this.mainForm.controls.endDate.value == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(this.mainForm.controls.endDate.value)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].end));
                  }
                  else
                    ctd.endTime = this.daysSelected[d].concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].end));// (this.mainForm.controls.endDate.value == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(this.mainForm.controls.endDate.value)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].end));

                  ctd.visitTypeId = slotList[i].extendedProps.visitTypeId;
                  // alert("blocktext is"+ slotList[0]._def.extendedProps.visitText);
                  ctd.visitCategoryId = 0;
                  ctd.visitCategoryName = '';
                  ctd.CTDayId = 0;
                  ctd.calendarTemplateId = 0;
                  //ctd.cDate = this.mainForm.value.startDate;
                  //ctd.cDateTo = this.mainForm.value.endDate==''?'2050-01-01': this.mainForm.value.endDate;
                  ctd.cDate = this.daysSelected[d];
                  ctd.cDateTo = this.daysSelected[d];
                  // var tempmedexpDate = this.datepipe.transform(this.mainForm.value.startDate, 'yyyy-MM-dd');
                  // ctd.cDate = tempmedexpDate != null ? new Date(tempmedexpDate) : null;
                  // if (this.mainForm.value.endDate != null && this.mainForm.value.endDate !== undefined && this.mainForm.value.endDate != '') {
                  //   var lowrevDate = this.datepipe.transform(this.mainForm.value.endDate, 'yyyy-MM-dd');
                  //   ctd.cDateTo = lowrevDate != null ? new Date(lowrevDate) : null;
                  // } else {
                  //   var lowrevDate = this.datepipe.transform('2050-01-01', 'yyyy-MM-dd');
                  //   ctd.cDateTo = lowrevDate != null ? new Date(lowrevDate) : null;
                  // }
                  //worked Code
                  //  ctd.cDate = (this.mainForm.value.startDate == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(this.mainForm.value.startDate)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].start));
                  // ctd.cDateTo = (this.mainForm.controls.endDate.value == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(this.mainForm.controls.endDate.value)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].end));

                  // ctd.bookinglimit = slotHour.slot[j].numBookings;
                  ctd.visitText = slotList[i]._def.extendedProps.visitText == null ? "" : slotList[i]._def.extendedProps.visitText;
                  var numbooking = slotList.filter(c => c.calendarTemplateId == ctd.calendarTemplateId && c.start == ctd.startTime && c.end == ctd.endTime);
                  ctd.bookinglimit = numbooking.length;// 1;
                  t.calendarTemplatesDays.push(ctd);
                }
              }
            }
          }
        }

        this.schedulerService.updateCalendarTemplate(t).subscribe(data => {
          this.templateList = null;
          ;
          if (data.includes('checked in')) {
            this.toastr.warning(data);
            this.isSaved = false;
            this.spinner.hide();
          }
          else if (data.includes('Conflict')) {
            this.toastr.warning(data);
            this.isSaved = false;
            this.spinner.hide();
          }
          else if (data.includes('already exists')) {
            this.toastr.warning(data);
            this.isSaved = false;
            this.spinner.hide();
          }
          else {
            this.toastr.success(data);
            this.mode = 0;
            this.refreshTemplates(this.chosenProvider.providerId, this.chosenLocation.locationId, t.calendarTemplateId);
            this.spinner.hide();
            this.getTemplateDays(new Date());
          }

          //  this.clear();
        },
          error => {
            this.isSaved = false;
            this.spinner.hide();
            //this.alertService.error("There was a problem loading availabilities: "+error);
          });
      }
      else {
        this.isSaved = false;
        this.toastr.warning('please add slots');
        this.spinner.hide();
      }
      // this.spinner.hide();
    } else {
      this.toastr.warning("Enter all the mandatory fields");
      this.isSaved = false;
      this.spinner.hide();
    }
  }

  onInactiveCheckBoxClick(event) {
    ;
    if (this.chosenProvider && this.chosenLocation && this.mainForm.controls.templateName.value && this.deactivatetemplateid !== 0) {
      if (event.checked) {
        const dialogRef2 = this.dialog.open(ConfirmationDialogComponent, {
          width: '325px',
          height: '160px',
          data: { headerText: 'Do you really want to De-Activate this Template?' }
        });
        dialogRef2.afterClosed().subscribe(dialogResult => {
          if (dialogResult) {
            //New Logic
            if (this.chosenProvider && this.chosenLocation && this.mainForm.controls.templateName.value && this.mainForm.value.chosenRecurrence !== '' && this.mainForm.value.startDate !== '' && this.mainForm.value.startDate !== null) {
              this.schedulerService.getAppCountbyTemplateId(this.deactivatetemplateid, sessionStorage.getItem("userId").toString()).subscribe(cnt => {
                if (cnt > 0) {
                  const dialogRef2 = this.dialog.open(ConfirmationDialogComponent, {
                    width: '325px',
                    height: '220px',
                    data: { headerText: 'Appointments are associated with this template. Editing will delete the appointments from Provider Calendar and will be moved to worklist. Do you wish to continue?' }
                  });
                  dialogRef2.afterClosed().subscribe(dialogResult => {
                    if (dialogResult) {
                      this.schedulerService.blockAppointmentbyTemplateId(this.edittingTemplate.providerId, this.deactivatetemplateid, this.edittingTemplate.locationId).subscribe(datas => {
                        this.toastr.success('Appointments moved to worklist');
                        this.DeActivateAfterCheck(false);
                      });
                    }
                  });
                }
                else {
                  this.DeActivateAfterCheck(false);
                }
              });
            }
            else {
              this.toastr.warning("Enter all the mandatory fields");
            }
          } else {
            this.editTemplate(this.selectedTemplate);
            // this.mainForm.patchValue({
            //   calendarInactive: false,
            // });
          }
        });
      } else {
        const dialogRef2 = this.dialog.open(ConfirmationDialogComponent, {
          width: '325px',
          height: '160px',
          data: { headerText: 'Do you really want to Activate this Template?' }
        });
        dialogRef2.afterClosed().subscribe(dialogResult => {
          if (dialogResult) {
            if (this.chosenProvider && this.chosenLocation && this.mainForm.controls.templateName.value && this.mainForm.value.chosenRecurrence !== '' && this.mainForm.value.startDate !== '' && this.mainForm.value.startDate !== null) {
              let slotList = this.calendar.getEvents();
              if (slotList && slotList.length) {
                let t = new CalendarTemplate;
                t.calendarTemplateId = this.edittingTemplate.calendarTemplateId;
                t.calendarTemplateName = this.mainForm.controls.templateName.value;
                t.calendarTemplateDescription = this.mainForm.controls.templateNotes.value;
                t.providerId = this.edittingTemplate.providerId;
                t.locationId = this.edittingTemplate.locationId;
                t.createdOn = this.edittingTemplate.createdOn;
                t.createdBy = this.edittingTemplate.createdBy;
                t.recurrence = this.mainForm.value.chosenRecurrence;
                t.modifiedOn = new Date();
                t.modifiedBy = sessionStorage.getItem("userId").toString();
                t.isActive = !this.mainForm.controls.calendarInactive.value;
                t.templateColor = this.mainForm.controls.templateColor.value;
                t.calendarTemplatesDays = [];

                // link to todays day FIXME
                let d = this.dateService.todayDateOnly();
                var weekdayNum = d.getDay();
                var chosenDay: string;
                if (weekdayNum == 0)
                  chosenDay = 'Sunday';
                else if (weekdayNum == 1)
                  chosenDay = 'Monday';
                else if (weekdayNum == 2)
                  chosenDay = 'Tuesday';
                else if (weekdayNum == 3)
                  chosenDay = 'Wednesday';
                else if (weekdayNum == 4)
                  chosenDay = 'Thursday';
                else if (weekdayNum == 5)
                  chosenDay = 'Friday';
                else if (weekdayNum == 6)
                  chosenDay = 'Saturday';

                let dayList: string[];
                switch (this.mainForm.controls.chosenRecurrence.value) {
                  case 'Monday to Friday':
                    dayList = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
                    break;
                  case 'Daily':
                    const d1: Date = moment(this.mainForm.controls.startDate.value).toDate();
                    const weekday = d1.getDay();
                    dayList = [];
                    if (weekday == 1)
                      dayList.push('Monday');
                    else if (weekday == 2)
                      dayList.push('Tuesday');
                    else if (weekday == 3)
                      dayList.push('Wednesday');
                    else if (weekday == 4)
                      dayList.push('Thursday');
                    else if (weekday == 5)
                      dayList.push('Friday');
                    else if (weekday == 6)
                      dayList.push('Saturday');
                    else
                      dayList.push('Sunday');
                    break;
                  case 'Custom-Series':
                    dayList = [];
                    if (this.mainForm.controls.dayMon.value == true)
                      dayList.push('Monday');
                    if (this.mainForm.controls.dayTue.value == true)
                      dayList.push('Tuesday');
                    if (this.mainForm.controls.dayWed.value == true)
                      dayList.push('Wednesday');
                    if (this.mainForm.controls.dayThu.value == true)
                      dayList.push('Thursday');
                    if (this.mainForm.controls.dayFri.value == true)
                      dayList.push('Friday');
                    if (this.mainForm.controls.daySat.value == true)
                      dayList.push('Saturday');
                    if (this.mainForm.controls.daySun.value == true)
                      dayList.push('Sunday');
                    break;
                  default:
                    dayList = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
                    break;
                }
                if (dayList.length == 0 && this.mainForm.value.chosenRecurrence === 'Custom-Series') {
                  this.toastr.warning("Please select any week day for Custom");
                  this.isSaved = false;
                  return;
                } else {
                  for (let d = 0; d < dayList.length; d++) {
                    for (let i = 0; i < slotList.length; i++) {
                      let ctd = new CalendarTemplateDay;
                      ctd.dayofweek = dayList[d];
                      ctd.startTime = (this.mainForm.controls.startDate.value == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(new Date(this.mainForm.controls.startDate.value))).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].start));
                      ctd.endTime = (this.mainForm.controls.endDate.value == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(new Date(this.mainForm.controls.endDate.value))).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].end));
                      ctd.visitTypeId = slotList[i].extendedProps.visitTypeId;
                      ctd.visitCategoryId = slotList[i].extendedProps.visitTypeId;
                      ctd.visitCategoryName = '';
                      ctd.CTDayId = 0;
                      ctd.calendarTemplateId = 0;
                      var tempmedexpDate = this.datepipe.transform(this.mainForm.value.startDate, 'yyyy-MM-dd');
                      ctd.cDate = tempmedexpDate != null ? moment(tempmedexpDate).toDate().toDateString() : null;
                      if (this.mainForm.value.endDate != null && this.mainForm.value.endDate !== undefined && this.mainForm.value.endDate != '') {
                        var lowrevDate = this.datepipe.transform(this.mainForm.value.endDate, 'yyyy-MM-dd');
                        ctd.cDateTo = lowrevDate != null ? moment(lowrevDate).toDate().toDateString() : null;
                      } else {
                        var lowrevDate = this.datepipe.transform('2050-01-01', 'yyyy-MM-dd');
                        ctd.cDateTo = lowrevDate != null ? moment(lowrevDate).toDate().toDateString() : null;
                      }
                      ctd.visitText = slotList[i]._def.extendedProps.visitText;
                      var numbooking = slotList.filter(c => c.calendarTemplateId == ctd.calendarTemplateId && c.start == ctd.startTime && c.end == ctd.endTime);
                      ctd.bookinglimit = numbooking.length;
                      t.calendarTemplatesDays.push(ctd);
                    }
                  }
                }
                this.schedulerService.checkCalendarTemplate(t, sessionStorage.getItem("userId").toString()).subscribe(cnt => {
                  if (cnt == 1) {
                    this.toastr.warning("Unable to Activate the template, Conflicts with one of the existing template");
                    this.mainForm.patchValue({
                      calendarInactive: true,
                    });
                  }
                  else {
                    this.DeActivateAfterCheck(true);
                  }
                },
                  error => {
                    this.isSaved = false;
                  });
              }
            }
            else {
              this.toastr.warning("Enter all the mandatory fields");
            }
          }
          else
            this.editTemplate(this.selectedTemplate);
        });
      }
    } else {
      this.toastr.warning('Please select the template');
      this.mainForm.patchValue({
        calendarInactive: false,
      });
      return false;
    }
  }

  DeActivateAfterCheck(status: boolean) {
    this.schedulerService.DeactivateCalenderTemplatesTService(this.deactivatetemplateid, status, '').subscribe(datas => {
      if (datas.includes('checked in')) {
        this.toastr.warning(datas);
        this.mainForm.patchValue({
          calendarInactive: false,
        });
        return false;
      } else if (datas.includes('failed')) {
        this.toastr.error(datas);
        this.mainForm.patchValue({
          calendarInactive: false,
        });
        return false;
      } else {
        this.toastr.success(datas);
        //navigate
        this.refreshTemplates(this.chosenProvider.providerId, this.chosenLocation.locationId);
        this.clear();
        this.getTemplateDays(new Date());
      }
    });
  }



  initBlankSlots() {
    this.eventsData = [];
    this.renderCalendar();
  }
  public extractTimeFromDateTimeString(dateTimeString: string): string {
    let dtTimeComponent = moment(dateTimeString).toDate();
    return this.padZero(dtTimeComponent.getHours()) + ':' +
      this.padZero(dtTimeComponent.getMinutes()) + ':' + this.padZero(dtTimeComponent.getSeconds());
  }
  private padZero(value: number): string {
    return ((value < 10 ? '0' : '').concat(value.toString()));
  }
  openSaveAsDialog(element) {
    const dialogRef = this.dialog.open(SaveAsDialogComponent, {
      width: '500px',
      height: 'auto',
      data: element
    });

    dialogRef.afterClosed().subscribe(
      data => {
        if (data) {
          let templateCopy = new CalendarTemplate;
          templateCopy = Object.assign({}, element);
          templateCopy.calendarTemplateId = element.calendarTemplateId;
          templateCopy.calendarTemplateName = data.newTemplateName;
          templateCopy.createdOn = new Date();
          //templateCopy.createdBy = provId;
          templateCopy.createdBy = sessionStorage.getItem("userId").toString();
          templateCopy.modifiedOn = new Date();
          //templateCopy.modifiedBy = provId;
          templateCopy.modifiedBy = sessionStorage.getItem("userId").toString();

          // let ccalendarTempDays = [];
          // for (let i = 0; i < templateCopy.calendarTemplatesDays.length; i++) {
          //   let ctd = templateCopy.calendarTemplatesDays[i];
          //   // ctd.CTDayId = 0;
          //   // ctd.calendarTemplateId = 0;
          //   // ctd.cDate = new Date();
          //   let dys = templateCopy.calendarTemplatesDays[i].dayofweek;
          //   let exdays = dys.split(', ');
          //   if (exdays.length > 0) {
          //     for (let n = 0; n <= exdays.length; n++) {
          //       if (exdays[n] != '') {
          //         let cttdy = new CalendarTemplateDay();
          //         cttdy.CTDayId = 0;
          //         cttdy.calendarTemplateId = 0;
          //         cttdy.dayofweek = exdays[n];
          //         cttdy.startTime = ctd.startTime;
          //         cttdy.endTime = ctd.endTime;
          //         cttdy.cDate = ctd.cDate;
          //         cttdy.cDateTo = ctd.cDateTo;
          //         cttdy.bookinglimit = ctd.bookinglimit;
          //         cttdy.visitCategoryId = ctd.visitCategoryId;
          //         ccalendarTempDays.push(cttdy);
          //       }
          //     }
          //   }
          // }
          // templateCopy.calendarTemplatesDays = ccalendarTempDays;

          this.schedulerService.insertCalendarTemplate({ ...templateCopy }, 'Copy').subscribe(data => {
            this.templateList = null;
            this.mode = 0;
            this.refreshTemplates(this.chosenProvider.providerId, this.chosenLocation.locationId);
          },
            error => {
              //this.alertService.error("There was a problem loading availabilities: "+error);
            });
        }
        else {
        }
      }
    );
  }
  selectedTemplateID: any
  openCopyTemplateDialog(element) {
    let dialogInput = new CopyTemplateDialogModel();
    this.selectedTemplateID = element;
    dialogInput.providersList = this.providersList;
    dialogInput.allLocations = this.allLocations;
    dialogInput.selectedTemplate = this.selectedTemplateID;
    const dialogRef = this.dialog.open(CopyTemplateDialogComponent, {
      width: '620px',
      height: '415px',
      data: dialogInput
    });

    dialogRef.afterClosed().subscribe(
      data => {
        if (data) {
          //IMPLEMENTED IN THE DIALOG BOX NOW
          ;
          //let needToReload: boolean = false;

          // let templateCopy = new CalendarTemplate;
          // templateCopy = Object.assign({}, element);
          // templateCopy.calendarTemplateId = element.calendarTemplateId;
          // templateCopy.calendarTemplateName = data.newTemplateName;
          // if (templateCopy.providerId == data.chosenProvider && templateCopy.locationId == data.chosenLocation)
          //   needToReload = true;
          // templateCopy.providerId = data.chosenProvider;
          // templateCopy.locationId = data.chosenLocation;
          // templateCopy.recurrence = data.chosenRecurrence;
          // templateCopy.createdOn = new Date();
          // //templateCopy.createdBy = provId;
          // templateCopy.createdBy = sessionStorage.getItem("userId").toString();
          // templateCopy.modifiedOn = new Date();
          // //templateCopy.modifiedBy = provId;
          // templateCopy.modifiedBy = sessionStorage.getItem("userId").toString();
          // let dayList: string[];
          // switch (data.chosenRecurrence) {
          //   case 'Monday to Friday':
          //     dayList = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
          //     break;
          //   case 'Once':
          //     const d1: Date = data.startDate;
          //     const weekday = d1.getDay();
          //     dayList = [];
          //     if (weekday == 1)
          //       dayList.push('Monday');
          //     else if (weekday == 2)
          //       dayList.push('Tuesday');
          //     else if (weekday == 3)
          //       dayList.push('Wednesday');
          //     else if (weekday == 4)
          //       dayList.push('Thursday');
          //     else if (weekday == 5)
          //       dayList.push('Friday');
          //     else if (weekday == 6)
          //       dayList.push('Saturday');
          //     else
          //       dayList.push('Sunday');
          //     break;
          //   case 'Custom':
          //     dayList = [];
          //     if (data.dayMon == true)
          //       dayList.push('Monday');
          //     if (data.dayTue == true)
          //       dayList.push('Tuesday');
          //     if (data.dayWed == true)
          //       dayList.push('Wednesday');
          //     if (data.dayThu == true)
          //       dayList.push('Thursday');
          //     if (data.dayFri == true)
          //       dayList.push('Friday');
          //     if (data.daySat == true)
          //       dayList.push('Saturday');
          //     if (data.daySun == true)
          //       dayList.push('Sunday');
          //     break;
          //   default:
          //     dayList = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
          //     break;
          // }
          // // for (let d = 0; d < dayList.length; d++) {
          // //   for (let i = 0; i < slotList.length; i++) {
          // //     let ctd = new CalendarTemplateDay;
          // //     ctd.dayofweek = dayList[d];;//''; // chosenDay;
          // //     // ctd.startTime = this.dateService.dateTimeAsString(slotList[i].start);
          // //     // ctd.endTime = this.dateService.dateTimeAsString(slotList[i].end);
          // //     ctd.startTime = (this.mainForm.controls.startDate.value == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(new Date(this.mainForm.controls.startDate.value))).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].start));
          // //     ctd.endTime = (this.mainForm.controls.endDate.value == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(new Date(this.mainForm.controls.endDate.value))).concat('T').concat(this.dateService.extractTimeFromDateTimeString(slotList[i].end));

          // //     ctd.visitTypeId = slotList[i].extendedProps.visitTypeId;

          // //     ctd.visitCategoryId = 0;
          // //     ctd.visitCategoryName = '';
          // //     ctd.CTDayId = 0;
          // //     ctd.calendarTemplateId = 0;
          // //     var tempmedexpDate = this.datepipe.transform(this.mainForm.value.startDate, 'yyyy-MM-dd');
          // //     ctd.cDate = tempmedexpDate != null ? new Date(tempmedexpDate) : null;
          // //     var lowrevDate = this.datepipe.transform(this.mainForm.value.endDate, 'yyyy-MM-dd');
          // //     ctd.cDateTo = lowrevDate != null ? new Date(lowrevDate) : null;
          // //     //ctd.cDate = this.mainForm.controls.startDate.value;
          // //     // ctd.cDateTo = this.mainForm.controls.endDate.value == '' ? '2050-01-01' : this.mainForm.controls.endDate.value;
          // //     // ctd.bookinglimit = slotHour.slot[j].numBookings;
          // //     ctd.visitText = slotList[i]._def.extendedProps.visitText;
          // //     var numbooking = slotList.filter(c => c.calendarTemplateId == ctd.calendarTemplateId && c.start == ctd.startTime && c.end == ctd.endTime);
          // //     ctd.bookinglimit = numbooking.length;// 1;
          // //     t.calendarTemplatesDays.push(ctd);
          // //   }
          // // }
          // let copytempdays = templateCopy.calendarTemplatesDays;
          // let ccalendarTempDays = [];
          // for (let i = 0; i < templateCopy.calendarTemplatesDays.length; i++) {
          //   let ctd = templateCopy.calendarTemplatesDays[i];
          //   // ctd.CTDayId = 0;
          //   // ctd.calendarTemplateId = 0;
          //   // ctd.cDate = new Date();
          //   let dys = templateCopy.calendarTemplatesDays[i].dayofweek;
          //   let exdays = dayList;// dys.split(', ');
          //   if (exdays.length > 0) {
          //     for (let n = 0; n <= exdays.length; n++) {
          //       if (exdays[n] != '') {
          //         let cttdy = new CalendarTemplateDay();
          //         cttdy.CTDayId = 0;
          //         cttdy.calendarTemplateId = 0;
          //         cttdy.dayofweek = exdays[n];
          //         // cttdy.startTime = ctd.startTime;
          //         // cttdy.endTime = ctd.endTime;
          //         cttdy.startTime = (data.startDate == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(data.startDate)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(ctd.startTime));
          //         cttdy.endTime = (data.endDate == '' ? "2050-01-01" : this.dateService.dateOnlyAsString(data.endDate)).concat('T').concat(this.dateService.extractTimeFromDateTimeString(ctd.endTime));

          //         var tempmedexpDate = this.datepipe.transform(data.startDate, 'yyyy-MM-dd');
          //         cttdy.cDate = tempmedexpDate != null ? new Date(tempmedexpDate) : null;
          //         if (data.endDate != null && data.endDate !== undefined && data.endDate != '') {
          //           var lowrevDate = this.datepipe.transform(data.endDate, 'yyyy-MM-dd');
          //           cttdy.cDateTo = lowrevDate != null ? new Date(lowrevDate) : null;
          //         } else {
          //           var lowrevDate = this.datepipe.transform('2050-01-01', 'yyyy-MM-dd');
          //           cttdy.cDateTo = lowrevDate != null ? new Date(lowrevDate) : null;
          //         }
          //         //cttdy.cDate = data.startDate;//ctd.cDate;
          //         //cttdy.cDateTo =data.endDate;// ctd.cDateTo;
          //         cttdy.bookinglimit = ctd.bookinglimit;
          //         cttdy.visitCategoryId = ctd.visitCategoryId;
          //         cttdy.visitTypeId = ctd.visitTypeId;
          //         cttdy.visitText =ctd.visitText;
          //         ccalendarTempDays.push(cttdy);
          //       }
          //     }
          //   }
          // }
          // templateCopy.calendarTemplatesDays = ccalendarTempDays;
          // this.schedulerService.insertCalendarTemplate(templateCopy, 'Copy').subscribe(data => {
          //   // this.snackBar.open("Template copied successfully.", "", {
          //   //   duration: 5000,
          //   //   verticalPosition: 'top',
          //   //   horizontalPosition: 'end',
          //   // });
          //   if (data.includes('Provider')) {
          //     this.toastr.warning(data);
          //   } else if (data.includes('success')) {
          //     this.toastr.success("Template copied successfully");
          //   }
          //   if (needToReload == true) {
          //     this.templateList = null;
          //     this.mode = 0;
          //     this.refreshTemplates(this.chosenProvider.providerId, this.chosenLocation.locationId);
          //   }
          // },
          //   error => {
          //     //this.alertService.error("There was a problem loading availabilities: "+error);
          //   });
          this.refreshTemplates(this.chosenProvider.providerId, this.chosenLocation.locationId);
        }
        else {
        }
      }
    );
  }
  public assignedTemplateList: AssignedListInfo[] = [];
  public calEventSources = [];

  displayEntriesOnCalendar() {
    //displayProviderEntries() {
    ;
    let colourList = ['#cefecc', '#eeccff', '#fff4a8', '#a0ceff', '#ff9595', '#d6b484', '#ff9966', '#f9ccca', '#40e0d0'];
    //get current month that is displayed
    //    let calStartDate = new Date(); // this.calendarComponent.getApi().view.currentStart;
    //    let calEndDate = new Date(); // this.calendarComponent.getApi().view.currentEnd;
    let dfd = this.calendar;
    let xx = '';
    //let filteredList: CalendarTemplateDay[] = [];

    /*
    this.calEventSources = [
      {
        events: [ // put the array in the `events` property
        ],
        color: '#85c705'
      },
      {
        events: [ // put the array in the `events` property
        ],
        color: '#fbaaa7', // border & background
      }
    ];
    */
    this.calEventSources = [
    ];
    //millie
    let newAssignedTemplateList: AssignedListInfo[] = [];

    /*
    
    
        if (this.templateList) {
          //let today = this.dateService.todayDateOnly();
          let lastColourIndex = 0;
          let lastTemplateIndex = 0;
          let addedTemplate = false;
          for (let i = 0; i < this.templateList.length; i++) {
            addedTemplate = false
            if (this.templateList[i].calendarTemplatesDays) {
              filteredList = this.templateList[i].calendarTemplatesDays.filter(entry => (new Date(entry.endTime)) >= today);
              if (filteredList) {
                for (let j = 0; j < filteredList.length; j++) {
                  let templateStart: Date = this.dateService.dateOnly(new Date(filteredList[j].startTime));
                  let templateEnd: Date = this.dateService.dateOnly(new Date(filteredList[j].endTime));
                  //let x = this.dateService.getAllTemplateDates(filteredList[j].dayofweek, calStartDate, templateStart, templateEnd);
                  let x;
                  if (x.length) {
                    addedTemplate = true;
                    this.calEventSources.push({events: [], color: colourList[lastColourIndex]});
                    for (let k = 0; k < x.length; k++) {
                      this.calEventSources[lastTemplateIndex].events.push({
                        start : x[k],
                        end : this.dateService.nextDay(x[k]),
                        allDay: true,
                        rendering: 'background'
                      });
                    }
                  }
                }
              }
              if (addedTemplate == true) {
                lastTemplateIndex = lastTemplateIndex + 1;
                if (lastColourIndex == (colourList.length - 1))
                  lastColourIndex = 0;
                else
                  lastColourIndex = lastColourIndex + 1;
              }
            }
          }
        }
    
    
    
    */


    //if (this.templateList) {
    //let today = this.dateService.todayDateOnly();

    let lastColourIndex = 0;
    let lastTemplateIndex = 0;
    let addedTemplate = false;
    for (let i = 0; i < this.templateList.length; i++) {
      addedTemplate = false
      for (let j = 0; j < this.templateList[i].calendarTemplatesDays.length; j++) {
        let ctd = this.templateList[i].calendarTemplatesDays[j];
        let templateStart: Date = this.dateService.dateOnly(moment(ctd.startTime).toDate());
        let templateEnd: Date = this.dateService.dateOnly(moment(ctd.endTime).toDate());
        let x = this.dateService.getAllTemplateDates(ctd.dayofweek, templateStart, templateEnd);
        if (x.length) {
          if (addedTemplate == false) {
            addedTemplate = true;
            let newColour: string = '';
            if (this.assignedTemplateList) {
              //keep the same colour if we are refreshing the list
              let y = this.assignedTemplateList.find(t => t.template.calendarTemplateId == this.templateList[i].calendarTemplateId);
              if (y)
                newColour = y.color;
            }
            if (newColour == "") {
              newColour = colourList[lastColourIndex];
              if (lastColourIndex == (colourList.length - 1))
                lastColourIndex = 0;
              else
                lastColourIndex = lastColourIndex + 1;
            }
            this.calEventSources.push({ events: [], color: newColour });
            let ali = new AssignedListInfo;
            ali.template = this.templateList[i];
            ali.color = newColour;
            newAssignedTemplateList.push(ali);
          }
          for (let k = 0; k < x.length; k++) {
            let dayOnly = this.dateService.dateOnly(x[k]);
            let dayOnlyStr = this.dateService.dateOnlyAsString(dayOnly);
            //using date here does not work...
            let y = this.calEventSources[lastTemplateIndex].events.find(e => e.extendedProps.strStart == dayOnlyStr);
            if (!y) {
              this.calEventSources[lastTemplateIndex].events.push({
                start: dayOnly,
                end: this.dateService.nextDay(dayOnly),
                allDay: false,// true,
                extendedProps: {
                  strStart: dayOnlyStr
                }
                //                ,
                //              rendering: 'background'
              });
            }
          }
        }
      }
      if (addedTemplate == true) {
        lastTemplateIndex = lastTemplateIndex + 1;
        //if (lastColourIndex == (colourList.length - 1))
        //  lastColourIndex = 0;
        //else
        //  lastColourIndex = lastColourIndex + 1;
      }
    }
    this.renderCalendar(this.dateService.dateOnlyAsString(this.calendar.view.currentStart));
    this.assignedTemplateList = newAssignedTemplateList;


    //get current month that is displayed
    //    var calStartDate = new Date(); // this.calendarComponent.getApi().view.currentStart;
    //  var calEndDate = new Date(); // this.calendarComponent.getApi().view.currentEnd;

  }

  onrecurrenceselectionchange(event) {
    ;
    if (this.mainForm.value.chosenRecurrence != null) {
      if (this.mainForm.value.chosenRecurrence == 'Daily') {
        this.mainForm.patchValue({
          endDate: this.mainForm.controls.startDate.value
        });
        // this.daysSelected = [];
      }
      if (this.mainForm.value.chosenRecurrence == 'Custom-Series') {
        this.mainForm.patchValue({
          dayMon: false,
          dayTue: false,
          dayWed: false,
          dayThu: false,
          dayFri: false,
          daySat: false,
          daySun: false,
        });
        // this.daysSelected = [];
      }
    }

  }

  // Get Templates based on Month

  async getCalenderTemplatesByMonth() {
    ;
    // var currDate: any = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
    // var currDate: any = this.datepipe.transform(this.currentdate, 'MM/dd/yyyy');   
    var datePipe = new DatePipe('en-US');
    if (this.mainForm.value.selectedMonthYear !== null && this.mainForm.value.selectedMonthYear !== undefined && this.selectMonthDp === true) {
      var currDate: any = datePipe.transform(this.mainForm.value.selectedMonthYear.toString(), 'MM/dd/yyyy');
    } else {
      var currDate: any = datePipe.transform(this.currentdate, 'MM/dd/yyyy');
    }
    this.currentdate = currDate;
    // var currDate: any = this.datepipe.transform(this.mainForm.value.selectedMonthYear, 'MM/dd/yyyy');
    this.eventsData = [];
    if (this.chosenProvider !== undefined) {
      await this.schedulerService.getTemplateByMonth(this.chosenProvider.providerId, currDate, this.chosenLocation.locationId)
        .subscribe((events: CalendarTemplateDay[]) => {
          // this.calenderEvents = events;
          events.map(element => {
            var obj = {
              title: element.title,
              start: element.startTime.toString(),
              end: element.endTime.toString(),
              backgroundColor: element.backgroundColor,
              borderColor: '#ccc',
              //allDay:true,
              extendedProps: {
                visitTypeId: element.visitTypeId,
                patName: element.patName,
                dob: element.dob,
                providerName: element.providerName,
                providerId: element.providerId,
                locationId: element.locationId,
                id: element.id,
                patId: element.patId
              },
            };
            this.eventsData.push(obj);
            this.renderCalendar();
          });
          this.renderCalendar();
          //this.BuildCalendar();
          // this.initilizeCalender();
          //this.calendar.gotoDate(this.datepipe.transform(this.SelectedDate, "yyyy-MM-dd"));
          // this.calendarHeaderDate = this.datePipe.transform(this.NewAppointmentForm.value.AppointmentDate, "yyyy-MM-dd");
          this.daymonthBtnView = true;
          this.selectMonthDp = true;
        });
    } else {
      this.toastr.warning('please select provider id and locationId')
    }
  }

  async getCalenderTemplatesByWeek() {
    ;
    // var currDate: any = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
    var datePipe = new DatePipe('en-US');
    var currDate: any = datePipe.transform(this.currentdate, 'MM/dd/yyyy');
    this.eventsData = [];
    await this.schedulerService.getCalendarTemplatesByWeek(this.chosenProvider.providerId, currDate, this.chosenLocation.locationId)
      .subscribe((events: CalendarTemplateDay[]) => {
        // this.calenderEvents = events;
        events.map(element => {
          var obj = {
            title: element.title,
            start: element.startTime.toString(),
            end: element.endTime.toString(),
            backgroundColor: element.backgroundColor,
            borderColor: '#ccc',
            //allDay:true,
            extendedProps: {
              visitTypeId: element.visitTypeId,
              patName: element.patName,
              dob: element.dob,
              providerName: element.providerName,
              providerId: element.providerId,
              locationId: element.locationId,
              id: element.id,
              patId: element.patId
            },
          };
          this.eventsData.push(obj);
          this.renderCalendar();
        });
        this.renderCalendar();
        //this.BuildCalendar();
        // this.initilizeCalender();
        //this.calendar.gotoDate(this.datepipe.transform(this.SelectedDate, "yyyy-MM-dd"));
        // this.calendarHeaderDate = this.datePipe.transform(this.NewAppointmentForm.value.AppointmentDate, "yyyy-MM-dd");
      });



  }
  editdays: any[] = [];
  daysSelected: any[] = [];
  event: any;
  minDate = new Date(2021, 1, 1);
  maxDate = new Date(2050, 1, 31);
  ismonthchange: boolean = false;
  isSelected = (event: any) => {
    // ;
    const date =
      moment(event).toDate().getFullYear() +
      "-" +
      ("00" + (moment(event).toDate().getMonth() + 1)).slice(-2) +
      "-" +
      ("00" + moment(event).toDate().getDate()).slice(-2);
    // if (this.currentmonth != event.getMonth() + 1) {
    //   this.ismonthchange = true;
    //   //  setTimeout(function () {       
    //   this.getTemplateDays(new Date(date));
    //   var lsl = this.calTemplateDays.filter(x => x == date);//? "selected" : null;
    //   if (lsl != null && lsl != undefined && lsl.length > 0)
    //     return "selecteds"
    //   // },1000);
    // }
    // else {

    // var tt = new CalendarTemplate();
    // tt.providerId = this.chosenProvider.providerId;
    // tt.locationId = this.chosenLocation.locationId;
    // tt.recurrence = 'Custom';
    // var ttdy = new CalendarTemplateDay();
    // ttdy.cDate = new Date(date);
    // tt.calendarTemplatesDays = [];
    // tt.calendarTemplatesDays.push(ttdy);
    // let calenday = "";
    // const weekday = event.getDay();
    // if (weekday == 1)
    //   calenday = 'Monday';
    // else if (weekday == 2)
    //   calenday = 'Tuesday';
    // else if (weekday == 3)
    //   calenday = 'Wednesday';
    // else if (weekday == 4)
    //   calenday = 'Thursday';
    // else if (weekday == 5)
    //   calenday = 'Friday';
    // else if (weekday == 6)
    //   calenday = 'Saturday';
    // else
    //   calenday = 'Sunday';

    var rsl = this.daysSelected.filter(x => x == date);//? "selected" : null;
    if (rsl != null && rsl != undefined && rsl.length > 0)
      return "selected"

    var rsl1 = this.editdays.filter(x => x == date);//? "selected" : null;
    if (rsl1 != null && rsl1 != undefined && rsl1.length > 0)
      return null// "selected"

    var lsl = this.calTemplateDays.filter(x => x == date);//? "selected" : null;
    if (lsl != null && lsl != undefined && lsl.length > 0)
      return "selecteds"



    // var rsl = this.daysSelected.filter(x => x == date);//? "selected" : null;
    // if (rsl != null && rsl != undefined && rsl.length > 0)
    //   return "selected"
    // else
    return null;
    //}

    //    setTimeout(function () {
    //      this.schService.checkforTemplateday(tt, '', '', calenday).subscribe(result => {
    //       // alert(result);
    //   if (result != 0) {
    //     //alert(result)
    //     // const index = this.daysSelected.findIndex(x => x == date);
    //     // if (index < 0) this.daysSelected.push(date);
    //     // else this.daysSelected.splice(index, 1);
    //     return "selected"
    //   }

    //   var rsl = this.daysSelected.filter(x => x == date);//? "selected" : null;
    //   if (rsl != null && rsl != undefined && rsl.length > 0)
    //     return "selected"
    //   else
    //     return null;
    // }   );
    // // var rsl = this.daysSelected.filter(x => x == date);//? "selected" : null;
    // // if (rsl != null && rsl != undefined && rsl.length > 0)
    // //   return "selected"
    // // else
    // //   return null;
    //    }, 500);
    // this.schedulerService.checkforTemplateday(tt, '', '', calenday).subscribe(result => {
    //   if (result == 1) {
    //     const index = this.daysSelected.findIndex(x => x == date);
    //     if (index < 0) this.daysSelected.push(date);
    //     else this.daysSelected.splice(index, 1);
    //     return "selecteds";
    //   }

    //   var rsl = this.daysSelected.filter(x => x == date);//? "selected" : null;
    //   if (rsl != null && rsl != undefined && rsl.length > 0)
    //     return "selected"
    //   else
    //     return null;
    // }
    // );
    // var rsl = this.daysSelected.filter(x => x == date);//? "selected" : null;
    // if (rsl != null && rsl != undefined && rsl.length > 0)
    //   return "selected"
    // else
    //   return null;
  };

  reloadcalendar(calendar: any) {
    ;
    // this.daysSelected=null;
    // this.daysSelected=this.editdays;
    //calendar.activeDate='01/01/2021';
    var datePipe = new DatePipe('en-US');
    var d1 = moment(this.currentdate).toDate();
    d1.setMonth(d1.getMonth() - 1);
    var prevdt = datePipe.transform(d1, "yyyy-MM-dd")

    this.select(moment(prevdt).toDate(), calendar);
    this.select(moment(prevdt).toDate(), calendar);
    calendar.updateTodaysDate();
  }

  select(event: any, calendar: any) {
    ;
    if (event != null) {
      const date =
        moment(event).toDate().getFullYear() +
        "-" +
        ("00" + (moment(event).toDate().getMonth() + 1)).slice(-2) +
        "-" +
        ("00" + moment(event).toDate().getDate()).slice(-2);
      var lsl = this.editdays.filter(x => x == date);//? "selected" : null;
      if (lsl != null && lsl != undefined && lsl.length > 0) {
        //   const index = this.daysSelected.findIndex(x => x == date);
        //   if (index < 0) this.daysSelected.push(date);
        //   else this.daysSelected.splice(index, 1);
        //   calendar.updateTodaysDate();
        //   return;
        // }        
        // else {
        const index = this.daysSelected.findIndex(x => x == date);
        if (index < 0) {
          this.daysSelected.push(date);
        }
        else {
          this.daysSelected.splice(index, 1);
          const ixx = this.calTemplateDays.findIndex(x => x == date);
          if (ixx >= 0)
            this.calTemplateDays.splice(ixx, 1);
        }
        return;
      }
      else {
        var lsl = this.calTemplateDays.filter(x => x == date);//? "selected" : null;
        if (lsl != null && lsl != undefined && lsl.length > 0) {
        }
        else {
          const index = this.daysSelected.findIndex(x => x == date);
          if (index < 0) {
            this.daysSelected.push(date);
          }
          else {
            this.daysSelected.splice(index, 1);
            const ixx = this.calTemplateDays.findIndex(x => x == date);
            if (ixx >= 0)
              this.calTemplateDays.splice(ixx, 1);
          }
        }
      }
      calendar.updateTodaysDate();
    }
    // alert(this.daysSelected);
  }
  monthSelectedd(event) {
    ;
    // alert(event);
    const date = moment(event.activeDate).toDate();
    //  if(this.currentmonth!=event.getMonth()+1)
    // {
    this.ismonthchange = true;
    //  setTimeout(function () {       
    this.getTemplateDays(moment(date).toDate());
    // },1000);
    event.updateTodaysDate();
    //this.select(null, event);
    //  var lsl = this.calTemplateDays.filter(x => x == date);//? "selected" : null;
    //  if (lsl != null && lsl != undefined && lsl.length > 0)
    //    return "selecteds"
    // },1000);
    //  }

  }
  isload: boolean = false;
  @ViewChild('calendarc', { static: true }) _calendarc: MatCalendar<Date>;
  @ViewChild('picker', { static: true }) _picker: MatDatepicker<Date>;
  // public dateClass = (date: Date) => {
  //   if (this._findDate(date) !== -1) {
  //     return [ 'selected' ];
  //   }
  //   return [ ];
  // }
  dateClass() {
    ;
    return (date: Date): MatCalendarCellCssClasses => {
      const highlightDate = this.daysSelected.map(strDate => moment(strDate).toDate())
        .some(d => d.getDate() === date.getDate() && d.getMonth() === date.getMonth() && d.getFullYear() === date.getFullYear());
      return highlightDate ? 'selected' : null;
    };
  }
  public CLOSE_ON_SELECTED = false;
  public init = new Date();
  public resetModel = new Date(0);
  public model = [];
  public dateChanged(event: MatDatepickerInputEvent<Date>): void {
    if (event.value) {
      const date = event.value;
      const index = this._findDate(date);
      if (index === -1) {
        this.model.push(date);
      } else {
        this.model.splice(index, 1)
      }
      this.resetModel = new Date(0);
      if (!this.CLOSE_ON_SELECTED) {
        const closeFn = this._picker.close;
        this._picker.close = () => { };
        this._picker['_popupComponentRef'].instance._calendar.monthView._createWeekCells()
        setTimeout(() => {
          this._picker.close = closeFn;
        });
      }
    }
  }

  public remove(date: Date): void {
    const index = this._findDate(date);
    this.model.splice(index, 1)
  }

  private _findDate(date: Date): number {
    return this.model.map((m) => +m).indexOf(+date);
  }
  calTemplateDays = [];
  currentmonth = '';
  public async getTemplateDays(currDate): Promise<any> {
    ;
    // const date =
    //   currDate.getFullYear() +
    //   "-" +
    //   ("00" + (currDate.getMonth() + 1)).slice(-2) +
    //   "-" +
    //   ("00" + currDate.getDate()).slice(-2);
    var datePipe = new DatePipe('en-US');
    var date = datePipe.transform(currDate, "yyyy-MM-dd")
    this.currentmonth = String((moment(date).toDate().getMonth()) + 1);
    var d = new Date(currDate);
    d.setMonth(d.getMonth() + 1);
    var nextdt = datePipe.transform(d, "yyyy-MM-dd")
    // alert(nextdt);
    var d1 = moment(currDate).toDate();
    d1.setMonth(d1.getMonth() - 1);
    var prevdt = datePipe.transform(d1, "yyyy-MM-dd")
    //alert(prevdt);
    await this.schedulerService.getTemplateByMonth(this.chosenProvider.providerId, date, this.chosenLocation.locationId)
      .subscribe((events: CalendarTemplateDay[]) => {
        // this.calenderEvents = events;
        var ll = this.calTemplateDays.filter(c => (moment(c).toDate().getMonth() + 1) == (moment(date).toDate().getMonth() + 1));
        if (ll != null && ll.length > 0) {
          ll.forEach(c => {
            const idxx = this.calTemplateDays.indexOf(c);
            this.calTemplateDays.splice(idxx, 1);
          });
        }
        // this.calTemplateDays.forEach(c=>{
        //   // if(((new Date(c)).getMonth()+1)==Number(this.currentmonth))
        //   if(((new Date(c)).getMonth()+1)==((new Date(date)).getMonth()+1))
        //   {
        //      const idxx=this.calTemplateDays.indexOf(c);
        //       this.calTemplateDays.splice(idxx,1);
        //   }

        // });
        events.map(element => {
          const idx = this.calTemplateDays.findIndex(x => x == datePipe.transform(element.startTime, "yyyy-MM-dd"));
          if (idx < 0)
            this.calTemplateDays.push(datePipe.transform(element.startTime, "yyyy-MM-dd"));
        });

        this.schedulerService.getTemplateByMonth(this.chosenProvider.providerId, nextdt, this.chosenLocation.locationId)
          .subscribe((events: CalendarTemplateDay[]) => {
            // this.calenderEvents = events;
            var ll = this.calTemplateDays.filter(c => (moment(c).toDate().getMonth() + 1) == (moment(nextdt).toDate().getMonth() + 1));
            if (ll != null && ll.length > 0) {
              ll.forEach(c => {
                const idxx = this.calTemplateDays.indexOf(c);
                this.calTemplateDays.splice(idxx, 1);
              });
            }
            events.map(element => {
              const idx = this.calTemplateDays.findIndex(x => x == datePipe.transform(element.startTime, "yyyy-MM-dd"));
              if (idx < 0)
                this.calTemplateDays.push(datePipe.transform(element.startTime, "yyyy-MM-dd"));
            });
          });
        this.schedulerService.getTemplateByMonth(this.chosenProvider.providerId, prevdt, this.chosenLocation.locationId)
          .subscribe((events: CalendarTemplateDay[]) => {
            // this.calenderEvents = events;
            var ll = this.calTemplateDays.filter(c => (moment(c).toDate().getMonth() + 1) == (moment(prevdt).toDate().getMonth() + 1));
            if (ll != null && ll.length > 0) {
              ll.forEach(c => {
                const idxx = this.calTemplateDays.indexOf(c);
                this.calTemplateDays.splice(idxx, 1);
              });
            }
            events.map(element => {
              const idx = this.calTemplateDays.findIndex(x => x == datePipe.transform(element.startTime, "yyyy-MM-dd"));
              if (idx < 0)
                this.calTemplateDays.push(datePipe.transform(element.startTime, "yyyy-MM-dd"));
            });
          });
        if (this.ismonthchange) {
          //   this.ismonthchange=false;
          //   var rsl = this.daysSelected.filter(x => x == date);//? "selected" : null;
          //   if (rsl != null && rsl != undefined && rsl.length > 0)
          //     return "selected"

          // var lsl = this.calTemplateDays.filter(x => x == date);//? "selected" : null;
          // if (lsl != null && lsl != undefined && lsl.length > 0)
          //   return "selecteds"

          //   return null;

        }
        return this.calTemplateDays;
      });
  }

  //   ngAfterViewInit() {
  //     let buttons = document.querySelectorAll('mat-calendar .mat-calendar-previous-button,' +
  //         'mat-calendar .mat-calendar-next-button');

  //     if (buttons) {
  //         Array.from(buttons).forEach(button => {
  //             this.renderer.listen(button, "click", () => {
  //             });
  //         })
  //     }
  // }
}


